var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHersteller = function SvgHersteller(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "hersteller_svg__Ebene_1",
    x: 0,
    y: 0,
    viewBox: "0 0 672 425"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".hersteller_svg__st2{fill:#edeff0}.hersteller_svg__st7{fill:#4591ce}.hersteller_svg__st8{fill:#2a0206}.hersteller_svg__st9{fill:#e4c3a9}.hersteller_svg__st10{fill:#fbdbad}.hersteller_svg__st11{fill:#f9ef98}.hersteller_svg__st12{fill:#f5e663}.hersteller_svg__st17{fill:#cdd0d3}.hersteller_svg__st18{fill:#b8bcbf}.hersteller_svg__st19{fill:#d8dbdc}.hersteller_svg__st20{fill:#505e5f}.hersteller_svg__st21{fill:#fff}.hersteller_svg__st22{fill:#c3c6c9}.hersteller_svg__st29{fill:#e2e5e6}.hersteller_svg__st30{fill:#4691ce}.hersteller_svg__st31{fill:#3b79ab}.hersteller_svg__st36{fill:#e5d353}.hersteller_svg__st37{fill:#ab927f}.hersteller_svg__st38{fill:#78645d}.hersteller_svg__st39{fill:#efdbcb}.hersteller_svg__st40{fill:#e3d1bc}.hersteller_svg__st41{fill:#fde9ce}.hersteller_svg__st42{fill:#bc9382}")), /*#__PURE__*/React.createElement("circle", {
    cx: 352.1,
    cy: 212.6,
    r: 191.6,
    style: {
      fill: "#cfe5d5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.1 425.3c-4 0-8.1-.1-12.1-.3l.1-2q6 .3 12 .3h.4v2zm12.6-.4-.1-2c4-.2 8-.6 12-1l.2 2c-4 .4-8.1.8-12.1 1m-36.8-1c-4-.5-8.1-1-12-1.7l.3-2c3.9.7 7.9 1.3 11.9 1.7zm60.9-1.8-.3-2c3.9-.7 7.9-1.5 11.8-2.4l.5 1.9c-4 1-8.1 1.8-12 2.5m-84.8-2.3c-3.9-.9-7.9-1.9-11.7-3.1l.6-1.9c3.8 1.1 7.7 2.2 11.6 3.1zm108.4-3.2-.6-1.9c3.8-1.1 7.7-2.4 11.4-3.7l.7 1.9c-3.8 1.3-7.6 2.5-11.5 3.7m-131.7-3.7c-3.8-1.4-7.6-2.8-11.3-4.4l.8-1.8c3.7 1.6 7.5 3 11.2 4.4zm154.5-4.5-.8-1.8c3.7-1.6 7.3-3.2 10.9-5l.9 1.8c-3.6 1.7-7.3 3.4-11 5m-176.9-4.9c-3.6-1.8-7.2-3.7-10.7-5.7l1-1.7c3.5 2 7.1 3.9 10.6 5.6zm198.6-5.9-1-1.7c3.5-2 6.9-4.1 10.3-6.2l1.1 1.7c-3.4 2.1-6.9 4.2-10.4 6.2m-219.8-6.1c-3.4-2.2-6.8-4.5-10-6.9l1.2-1.6c3.2 2.4 6.6 4.6 9.9 6.8zm240.2-7.1-1.2-1.6c3.2-2.4 6.4-4.8 9.5-7.4l1.3 1.5c-3.1 2.7-6.4 5.2-9.6 7.5m-259.8-7.2c-3.1-2.6-6.2-5.2-9.2-8l1.4-1.5c2.9 2.7 6 5.4 9.1 7.9zM496 369l-1.4-1.5c2.9-2.7 5.8-5.5 8.6-8.4l1.4 1.4c-2.7 3-5.6 5.8-8.6 8.5m-296.4-8.3c-2.8-2.9-5.6-5.9-8.2-8.9l1.5-1.3c2.6 3 5.4 6 8.1 8.9zm313.3-9.1-1.5-1.3c2.6-3 5.2-6.2 7.6-9.3l1.6 1.2c-2.5 3.2-5 6.4-7.7 9.4m-329.2-9.2c-2.5-3.2-4.9-6.5-7.1-9.8l1.6-1.1c2.3 3.3 4.6 6.6 7.1 9.7zm344-10-1.7-1.1c2.3-3.3 4.4-6.7 6.5-10.1l1.7 1c-2 3.4-4.2 6.8-6.5 10.2m-357.7-10c-2.1-3.4-4.1-7-6-10.5l1.8-.9c1.9 3.5 3.9 7 5.9 10.4zm370.3-10.8-1.8-.9c1.9-3.5 3.7-7.2 5.3-10.8l1.8.8c-1.6 3.6-3.4 7.3-5.3 10.9M158.7 301c-1.7-3.7-3.3-7.4-4.7-11.2l1.9-.7c1.5 3.7 3 7.4 4.7 11zm391.7-11.5-1.9-.7c1.4-3.7 2.8-7.5 4-11.3l1.9.6c-1.2 3.8-2.6 7.6-4 11.4m-400.5-11.1c-1.2-3.8-2.4-7.7-3.4-11.6l1.9-.5c1 3.9 2.2 7.7 3.4 11.5zm408-12-1.9-.5q1.5-5.85 2.7-11.7l2 .4c-.9 3.9-1.8 7.9-2.8 11.8m-414.2-11.5c-.8-3.9-1.5-8-2.1-12l2-.3c.6 4 1.3 7.9 2 11.8zm418.9-12.3-2-.3c.6-3.9 1-8 1.3-11.9l2 .2c-.2 3.9-.7 8-1.3 12m-422.4-11.7c-.3-4-.6-8.1-.7-12.1l2-.1c.1 4 .3 8 .7 12zm424.5-12.5-2-.1c.1-1.9.1-3.8.1-5.7 0-2.1 0-4.2-.1-6.3l2-.1c.1 2.1.1 4.3.1 6.4-.1 2-.1 3.9-.1 5.8m-423.2-11.7-2-.1c.1-4 .3-8.1.7-12.1l2 .2c-.3 4-.6 8-.7 12m420.4-12.4c-.3-4-.8-8-1.4-11.9l2-.3c.6 4 1 8 1.4 12.1zm-418.3-11.5-2-.3q.9-6 2.1-12l2 .4c-.9 3.9-1.6 7.9-2.1 11.9m414.9-12.3q-1.2-5.85-2.7-11.7l1.9-.5c1 3.9 2 7.9 2.8 11.8zm-410.2-11.3-1.9-.5c1-3.9 2.2-7.8 3.4-11.6l1.9.6c-1.2 3.8-2.4 7.7-3.4 11.5m404.1-11.9c-1.2-3.8-2.6-7.6-4.1-11.3l1.9-.7c1.5 3.8 2.9 7.6 4.1 11.4zm-396.6-11-1.9-.7c1.5-3.8 3.1-7.5 4.7-11.2l1.8.8c-1.6 3.7-3.2 7.4-4.6 11.1m387.8-11.4c-1.7-3.6-3.5-7.2-5.3-10.8l1.8-.9c1.9 3.6 3.7 7.2 5.4 10.9zm-377.8-10.5-1.8-.9c1.9-3.6 3.9-7.1 6-10.6l1.7 1c-2.1 3.5-4.1 7-5.9 10.5m366.5-10.7c-2.1-3.4-4.3-6.8-6.5-10.1l1.6-1.1q3.45 4.95 6.6 10.2zm-354.1-9.8-1.6-1.1c2.3-3.3 4.7-6.6 7.1-9.8l1.6 1.2c-2.4 3.1-4.8 6.4-7.1 9.7m340.5-10c-2.4-3.2-5-6.3-7.6-9.3l1.5-1.3c2.6 3 5.2 6.2 7.7 9.4zm-325.8-9.1-1.5-1.3c2.6-3 5.4-6.1 8.2-8.9L201 66c-2.7 2.8-5.5 5.8-8.1 8.8m310.1-9c-2.8-2.9-5.7-5.7-8.6-8.4l1.4-1.5c3 2.7 5.9 5.6 8.7 8.5zm-293.3-8.2-1.4-1.5c3-2.7 6-5.4 9.2-8l1.3 1.5c-3.1 2.6-6.2 5.3-9.1 8m275.5-8.1c-3.1-2.5-6.3-5-9.5-7.3l1.2-1.6c3.3 2.4 6.5 4.9 9.6 7.4zm-256.9-7.2-1.2-1.6c3.3-2.4 6.6-4.7 10-6.9l1.1 1.7c-3.4 2.2-6.7 4.5-9.9 6.8m237.5-6.9c-3.4-2.2-6.8-4.3-10.3-6.2l1-1.7c3.5 2 7 4.1 10.4 6.3zm-217.4-6.1-1-1.7c3.5-2 7.1-3.9 10.7-5.7l.9 1.8c-3.5 1.8-7.1 3.6-10.6 5.6m196.4-5.8c-3.6-1.8-7.3-3.5-11-5l.8-1.8q5.55 2.4 11.1 5.1zM270 18.7l-.8-1.8c3.7-1.6 7.5-3.1 11.3-4.4l.7 1.9c-3.8 1.2-7.6 2.7-11.2 4.3m152.7-4.5c-3.8-1.3-7.6-2.6-11.5-3.7l.6-1.9c3.9 1.1 7.8 2.4 11.6 3.8zm-130.1-3.6-.6-2c3.9-1.1 7.8-2.2 11.7-3.1l.5 1.9c-3.9 1-7.8 2-11.6 3.2m107-3.2c-3.9-.9-7.8-1.7-11.8-2.4l.3-2c4 .7 8 1.5 11.9 2.4zM316 5.1l-.3-2c4-.7 8-1.3 12-1.7l.2 2c-4 .4-8 1-11.9 1.7m59.9-1.8c-4-.4-8-.8-12-1l.1-2c4 .2 8.1.6 12.1 1zm-36-.9-.1-2c4-.2 8.1-.4 12.1-.4v2c-4 0-8.1.1-12 .4",
    style: {
      fill: "#8bbf9e"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M594.6 172c-1.2 4.8-1.4 13.2-1.4 19l-3.9-8.2 2.9-5.6c-2.6-.7-4.2-1.1-4.2-1.1s2.2-2.4 6.6-4.1",
    className: "hersteller_svg__st2"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hersteller_svg__SVGID_1_",
    x1: 313.272,
    x2: 377.776,
    y1: 301.698,
    y2: 245.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m343.3 327.1-89-51.8 88.5-51.1 89 51.8z",
    style: {
      fill: "url(#hersteller_svg__SVGID_1_)"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M619.7 184.4c1.1 6.4 1.3 10.9-.3 12.6s-20-4-22.1-9.6c-1.6-4.2-.4-12.4.4-16.4 3.7-.9 8.4-1.1 13.9.7 3.6 1.1 7 2.4 10.1 4-1.4 2.1-2.6 5.2-2 8.7M636.3 195.6q-3.15.45-6.3 1.5c-.8.3-1.7.5-2.4.8-6.5-8-4.7-16.7-3.3-20.7 6.3 3.9 10.7 9.5 12 18.4",
    className: "hersteller_svg__st2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m598.6 199.7-.2 2.1-1.4-2.9z",
    style: {
      fill: "#00dad5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m598.4 201.8 1.3 2.7-1.6-.1z",
    style: {
      fill: "none",
      stroke: "#e5b59e",
      strokeWidth: 1.6341,
      strokeMiterlimit: 10
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M624.5 298.4s-.2-35.9-3.9-49.1c-.8-2.8-6-11.6-9.9-6.3-4.7 6.4-1.9 52.6-1.9 52.6L599 294l1.9-86.9-1.3-2.6 5.3.1 16.7 11.6s5 2.9 9.2.7l2.4 83.8z",
    className: "hersteller_svg__st7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M621.6 152.5s1 9.8-5 12.6-.1-10.5-.1-10.5z",
    className: "hersteller_svg__st8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m607 160.6-1.2 14.6s-1 4.6 3.6 4 7.2-2.9 7.3-5.2v-13.5H607z",
    className: "hersteller_svg__st9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M619.9 157c-.4-.2-.9-.2-1.4-.1 0-.4.1-.8.1-1.3l1.9-8.9c-1.7-5-5.1-8.6-9.6-9.2-7-.9-13.7 6.2-14.9 15.8s3.9 21.6 10.4 19.1c2.7-1.1 5.5-2.3 7.9-4 1.1-.8 1.9-2.1 2.2-3.4l.6-3c.9.2 2-.4 2.8-1.6 1-1.3.9-2.8 0-3.4",
    className: "hersteller_svg__st10"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M618.5 157s-1.6 1.4-1.7 2-.3 1.4-.3 1.4l-.9-.1 1.8-5.2 2.8-.8-.2 2.1z",
    className: "hersteller_svg__st8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M622.3 151.7c-18.6 5.4-26-2.1-26-2.1-1.3-3.6 5.2-15.4 14.9-13.8 9.7 1.5 11.9 10.9 11.1 15.9",
    className: "hersteller_svg__st11"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M622.3 151.7c-7.2 2.1-12.7 2.2-16.8 1.7-.3-2-.7-7.7 2.6-12.3q2.4-3.3 6.6-5.1c-1-.5-2.2-.8-3.5-1l-.4-.1c-.6-.1-1.2-.1-1.7-.1-1.6 1.2-3 2.6-4.1 4.2-3.4 4.9-3.6 10.4-3.4 13.6 1.1.3 2.3.6 3.8.9-6.4-.9-9.1-3.7-9.1-3.7s-3-.7-2.3 2.1c.7 2.9 9.4 9.1 21.8 5.4 7.1-3.2 6.5-5.6 6.5-5.6",
    className: "hersteller_svg__st12"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M626.8 208.6s-17.7-8.1-18.7-9.6-8.5-7.7-8.5-7.7l-1 8.4-1.6-.8-3.9-7.9c0-5.8.2-14.2 1.4-19 .9-.4 1.9-.7 3.1-1-.7 4-1.9 12.2-.4 16.4 2.1 5.7 20.6 11.3 22.1 9.6 1.6-1.7 1.4-6.2.3-12.6-.6-3.5.7-6.6 2-8.7.9.5 1.8 1 2.6 1.5-1.4 3.9-3.2 12.7 3.3 20.7.8 5.5-.7 10.7-.7 10.7",
    className: "hersteller_svg__st7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m601 179.9-.1 39.7-24.4-14.1.1-39.7z",
    style: {
      fill: "#7b6155"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m601 179.9 1.6-.9-.1 39.7-1.6.9z",
    style: {
      fill: "#b18c7a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m576.6 165.8 1.5-.9 24.5 14.1-1.6.9z",
    style: {
      fill: "#c59c88"
    }
  }), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M636.3 195.6q-3.15.45-6.3 1.5c-.8.3-1.7.5-2.4.8.7 5.5-.9 10.8-.9 10.8s-17.7-8.1-18.7-9.6c-.7-1.1-3.4-4.2-5.9-6.2-.9-.7-3.1 0-4.5.5-1.1.5-1.5 4.2-.7 6.7.3.8.9 3.5 2.7 4.4 1.2.6 5.3.1 5.3.1l16.7 11.6s5 2.9 9.2.7c2.7-1.4 5.2-5 5.6-13 .4-3.1.3-5.8-.1-8.3",
    className: "hersteller_svg__st10"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m520.3 105.8.4 119.4-88.6 51.2-.3-119.5z",
    className: "hersteller_svg__st17"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m432.1 276.4-89-51.8-.3-119.4 89 51.7z",
    className: "hersteller_svg__st18"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m431.8 156.9-89-51.7 88.5-51.1 89 51.7z",
    className: "hersteller_svg__st19"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m383.9 199.6-1 .6-.2-.2-.1-.1s0-.1-.1-.1l-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1s-.1 0-.1-.1L350.8 181h-.1s-.1 0-.1-.1h-.4c-.1 0-.2-.1-.3-.1h-.5c-.1 0-.1 0-.2.1h-.2l1-.6c.1 0 .1-.1.2-.1h1.3s.1 0 .1.1h.1l30.6 17.7s.1 0 .1.1c0 0 .1 0 .1.1 0 0 .1 0 .1.1l.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1z",
    className: "hersteller_svg__st17"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m383.7 202.9-.1 35.2v.4c0 .1 0 .1-.1.2v.2c0 .1-.1.1-.1.2l-.1.1-.1.1-.1.1-.1.1c-.4.3-1.1.2-1.7-.2l-30.6-17.7c-1.3-.8-2.4-2.7-2.4-4.2l.1-35.2c0-.8.3-1.4.8-1.6h.1c.1 0 .1-.1.2-.1h.6c.1 0 .2 0 .3.1h.1s.1 0 .1.1h.1s.1 0 .1.1h.1l30.6 17.7s.1 0 .1.1c0 0 .1 0 .1.1 0 0 .1 0 .1.1l.1.1.1.1c.1 0 .1.1.2.1l.1.1.1.1.1.1.1.1.1.1c0 .1.1.1.1.2.1.1.1.2.2.3s.1.2.1.2c0 .1.1.1.1.2l.1.1c0 .1.1.2.1.2 0 .1.1.1.1.2v1.2z",
    className: "hersteller_svg__st20"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m384.8 202.3-.1 35.2v.7s0 .1-.1.1c0 .1-.1.1-.1.2-.1.2-.3.3-.4.4l-1 .6.1-.1.1-.1.1-.1.1-.1c0-.1.1-.1.1-.2v-.7999999999999999l.1-35.2v-1.6000000000000003s0-.1-.1-.1c0 0 0-.1-.1-.1 0-.1 0-.1-.1-.1 0-.1-.1-.1-.1-.2-.1-.1-.1-.2-.1-.2v-.1l1-.6c.1.1.1.2.2.3 0 .1.1.1.1.2s.1.1.1.1 0 .1.1.1c0 0 0 .1.1.1 0 0 0 .1.1.1v1.3zM351.2 183.9v.7999999999999999c0 .1-.1.1-.2.2l-1 .6.1-.1v-1.9000000000000006s0-.1-.1-.1c0 0 0-.1-.1-.1 0 0 0-.1-.1-.1v-.2h-.4l1-.6h.5l.1.1v.2s0 .1.1.1l.1.1s0 .1.1.1v1.0999999999999999z",
    className: "hersteller_svg__st19"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M350.2 184.6v.2c0 .1 0 .2-.1.2v.1l-.1.1c-.2.1-.4.1-.7-.1-.6-.3-1-1.1-1-1.8 0-.3.1-.6.3-.7.1 0 .1-.1.2-.1h.1s.1 0 .1.1h.1v.2c0 .1.1.1.1.2 0 0 0 .1.1.1v.1c0 .1 0 .1.1.2v.6c.8.4.8.5.8.6 0-.1 0 0 0 0",
    className: "hersteller_svg__st21"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M382 201.7v.8l-.2.2-1 .6h.1l.1-.1v-1.9s0-.1-.1-.1c0 0 0-.1-.1-.1 0 0 0-.1-.1-.1l-.1-.1v-.1l-.1-.1h-.5l1-.6h.6v.2s0 .1.1.1l.1.1s0 .1.1.1v1.2c.1-.3.1-.2.1-.1q0-.15 0 0",
    className: "hersteller_svg__st19"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M380.9 202.3v.7c0 .1-.1.1-.1.1-.2.1-.5.1-.8 0-.6-.3-1-1.1-1-1.8 0-.3.1-.6.3-.7.1 0 .1-.1.2-.1h.5l.1.1.1.1v.2s0 .1.1.1l.1.1s0 .1.1.1c0 0 0 .1.1.1v.8zM350.1 219.8q0 .15 0 0v.5c0 .1-.1.1-.1.1-.2.1-.5.1-.8 0-.6-.3-1-1.1-1-1.8 0-.3.1-.6.3-.7h.4l.1.1s0 .1.1.1v.1s0 .1.1.1l.1.1s0 .1.1.1v1.2c.7 0 .7.1.7.1",
    className: "hersteller_svg__st21"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M351.1 219.1v.7999999999999999l-.2.2-1 .6h.1l.1-.1v-2.1000000000000005s0-.1-.1-.1c0 0 0-.1-.1-.1 0 0 0-.1-.1-.1v-.2h-.5l1-.6h.6v.1s0 .1.1.1l.1.1s0 .1.1.1v1.3c-.1-.1-.1-.1-.1 0M381.9 237v.7c0 .1-.1.1-.2.2l-1 .6.1-.1v-1.7000000000000004s0-.1-.1-.1v-.1s0-.1-.1-.1l-.1-.1s0-.1-.1-.1l-.1-.1h-.30000000000000004l1-.6h.4v.2s0 .1.1.1l.1.1s0 .1.1.1v1.4000000000000001zq0-.15 0 0",
    className: "hersteller_svg__st19"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M380.8 237.5q0 .15 0 0v.7l-.1.1c-.2.1-.4.1-.7-.1-.6-.3-1-1.1-1-1.8 0-.3.1-.6.3-.7h.2l.1.1c.1.1.1.1.1.2 0 0 0 .1.1.1v.1s0 .1.1.1v.6c.9.5.9.5.9.6",
    className: "hersteller_svg__st21"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m517.6 114.7.3 108.1-80.1 46.3-.3-108.1z",
    className: "hersteller_svg__st19"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m437.8 269.1-1.9-1.1-.3-108.1 1.9 1.1z",
    className: "hersteller_svg__st18"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m437.5 161-1.9-1.1 80.1-46.3 1.9 1.1z",
    className: "hersteller_svg__st21"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M614.6 349.4v11.4l-164.5-95v-11.4z",
    className: "hersteller_svg__st18"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "m614.6 349.4 57.6-33.5v11.4l-57.6 33.5z",
    className: "hersteller_svg__st22"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "m450.1 254.4 57.6-33.5 164.5 95-57.6 33.5z",
    className: "hersteller_svg__st19"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hersteller_svg__SVGID_2_",
    x1: 243.48,
    x2: 532.45,
    y1: 69.507,
    y2: 275.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2f3838"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    style: {
      stopColor: "#313a3a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    style: {
      stopColor: "#374141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    style: {
      stopColor: "#414c4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#4f5d5e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#505e5f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m508.4 221.2-58.1 33.6v-3.1l55.5-32z",
    style: {
      fill: "url(#hersteller_svg__SVGID_2_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hersteller_svg__SVGID_3_",
    x1: 281.823,
    x2: 570.793,
    y1: 15.827,
    y2: 222.234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2f3838"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    style: {
      stopColor: "#313a3a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    style: {
      stopColor: "#374141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    style: {
      stopColor: "#414c4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#4f5d5e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#505e5f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m508.4 221.2-2.6-1.5-.2-84.6 2.6-1.5z",
    style: {
      fill: "url(#hersteller_svg__SVGID_3_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hersteller_svg__SVGID_4_",
    x1: 264.078,
    x2: 553.047,
    y1: 40.67,
    y2: 247.077,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2f3838"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    style: {
      stopColor: "#313a3a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    style: {
      stopColor: "#374141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    style: {
      stopColor: "#414c4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#4f5d5e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#505e5f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m505.8 219.7-55.5 32-.2-84.6 55.5-32z",
    style: {
      fill: "url(#hersteller_svg__SVGID_4_)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.6 337.5v-2.6c0-.1 0-.2-.1-.3 0-.1 0-.1-.1-.2v-.2c0-.1 0-.2-.1-.2 0-.1-.1-.3-.1-.4-.1-.2-.1-.4-.2-.6v-.1c-.1-.2-.1-.3-.2-.5s-.1-.3-.2-.5-.1-.3-.2-.5-.1-.3-.2-.5-.1-.3-.2-.5-.1-.3-.2-.5-.2-.4-.3-.5l-.3-.6c-.2-.3-.3-.6-.5-.9-.2-.4-.5-.8-.8-1.2l-.6-.9c-.1-.1-.1-.2-.2-.3 0-.1-.1-.1-.1-.1 0-.1-.1-.1-.1-.1-.1-.2-.3-.3-.4-.5-.1-.1-.3-.3-.4-.5l-.4-.4-.4-.4-.4-.4-.1-.1c-.1-.1-.3-.2-.4-.3l-.4-.4c-.1-.1-.3-.2-.4-.4-.1-.1-.2-.2-.3-.2l-.1-.1c-.1-.1-.3-.2-.4-.3s-.3-.2-.4-.3-.3-.2-.4-.3c0 0-.1 0-.1-.1l-137.1-79.1-23.5-13.5v3.6l20.1 11.6 32.9 19 9.2 5.3 3.7 2.1 9.2 5.3 3.7 2.1 9.3 5.4 44.9 25.9 8.9 5.2 4 2.3 6.9 4 2 1.1 4 2.3 1.5.9c3.8 2.2 6.8 7.5 6.9 11.8v1.2c0 .1 0 .2-.1.3 0 .1 0 .2-.1.3 0 .1 0 .2-.1.3 0 .1-.1.2-.1.3s-.1.2-.1.3-.1.2-.1.3-.1.2-.1.3-.1.1-.1.2l-.1.1-.3.3c-.1.1-.2.3-.4.4l-.1.1c-.1.1-.2.1-.3.2h-.1l-.3.1c-.1 0-.1 0-.2.1h-.2c-.1 0-.2.1-.4.1-.1 0-.2 0-.4.1h-1.5c-.1 0-.2 0-.3-.1-.1 0-.2-.1-.3-.1h-.3s-.1 0-.1-.1c0 0-.1 0-.1-.1-.1 0-.2-.1-.3-.1s-.2-.1-.3-.1-.1-.1-.2-.1l-6.9-4-3.5-2-9.5-5.5-3.4-2-9.5-5.5-44.7-25.9-9.1-5.3-3.7-2.2-9.2-5.3-3.7-2.1-9.3-5.4-41.4-23.9-6.3-3.6v3.7l3.1 1.8 157 90.7c2.8 1.6 5.3 1.8 7.1.7.1 0 .1-.1.2-.1.1-.1.2-.2.3-.2.1-.1.2-.1.2-.2l.2-.2c.2-.2.4-.4.6-.7l.2-.3c0-.1.1-.1.1-.2s.1-.1.1-.2c.1-.1.1-.2.2-.3.1-.2.1-.3.2-.5 0-.1.1-.1.1-.2s.1-.2.1-.3c.1-.2.1-.3.1-.5s.1-.3.1-.5.1-.3.1-.5v-1.4c.3-.3.3-.5.3-.6",
    style: {
      fill: "#2f3838"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.7 340.2c-.1.1-.2.1-.3.2s-.2.1-.3.2c-.1 0-.1 0-.2.1h-.2c-.1 0-.2.1-.4.1-.1 0-.2 0-.4.1h-1.4c-.1 0-.2 0-.3-.1-.1 0-.2-.1-.3-.1h-.4s-.1 0-.1-.1c-.1 0-.2-.1-.3-.1s-.2-.1-.3-.1-.1-.1-.2-.1l-6.9-4-3.5-2-9.5-5.5-3.4-2-9.5-5.5-44.8-26-9.1-5.3-3.7-2.2-9.2-5.3-3.7-2.1-9.3-5.4-41.4-23.9-6.3-3.6v-2.7l8.7 5 37.7 21.7 2.3 1.3 4.9 2.8.4.2 4.4 2.5.9.5 2.2 1.3 4.9 2.9.4.2 4.3 2.5 1 .6 2.2 1.3 4.9 2.8.4.2 4.4 2.5 1 .6 41 23.7 2.3 1.3 5 2.9.5.3 4.2 2.4.8.5.3.2 2 1.1 5 2.9.5.3 4.2 2.4.9.5.3.2 2 1.1 5 2.9.5.3 4.3 2.5 1.1.6.2.1c.2.3.3.3.3.3",
    style: {
      fill: "#485657"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hersteller_svg__SVGID_5_",
    x1: 258.025,
    x2: 546.994,
    y1: 49.145,
    y2: 255.552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#2f3838"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.524,
    style: {
      stopColor: "#313a3a"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727,
    style: {
      stopColor: "#374141"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.874,
    style: {
      stopColor: "#414c4d"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994,
    style: {
      stopColor: "#4f5d5e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#505e5f"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M667.7 310.5v1c0 .2 0 .3-.1.5 0 .2 0 .3-.1.5 0 .2-.1.3-.1.5s-.1.3-.1.5c-.1.2-.1.4-.2.5-.1.2-.2.4-.2.6-.1.2-.2.5-.4.7-.5.7-1.1 1.3-1.7 1.7l-47 27.3c.1-.1.2-.2.3-.2.1-.1.2-.1.2-.2l.2-.2c.2-.2.4-.4.6-.7.1-.1.1-.2.2-.3l.1-.1c0-.1.1-.1.1-.2.1-.1.1-.2.2-.3.1-.2.1-.3.2-.5v-.2c0-.1.1-.2.1-.3.1-.2.1-.3.1-.5s.1-.3.1-.5 0-.3.1-.5v-4.4c0-.1 0-.2-.1-.3v-.3c0-.1 0-.1-.1-.2 0-.1 0-.2-.1-.2 0-.1-.1-.3-.1-.4v-.1c0-.2-.1-.3-.1-.5v-.1c-.1-.2-.1-.3-.2-.5s-.1-.3-.2-.5-.1-.3-.2-.5-.1-.3-.2-.5-.1-.3-.2-.5-.1-.3-.2-.5-.2-.4-.3-.5l-.3-.6c-.2-.3-.3-.6-.5-.9-.2-.4-.5-.8-.8-1.2l-.6-.9c-.1-.1-.1-.2-.2-.3 0-.1-.1-.1-.1-.1l-.1-.1c-.1-.2-.3-.3-.4-.5-.1-.1-.3-.3-.4-.5l-.4-.4-.4-.4-.4-.4-.1-.1c-.1-.1-.3-.2-.4-.3l-.4-.4c-.1-.1-.3-.2-.4-.4-.1-.1-.2-.2-.3-.2l-.1-.1c-.1-.1-.3-.2-.4-.3s-.3-.2-.4-.3-.3-.2-.4-.3c0 0-.1 0-.1-.1l-137.1-79.1-23.3-13.7-.1-31.5 17-9.9c.3-.1.5-.3.8-.4.2-.1.5-.1.7-.2.2 0 .4-.1.6-.1h1.4c.1 0 .3 0 .4.1.1 0 .3.1.4.1s.3.1.4.1.3.1.4.1.3.1.4.2.3.1.4.2.3.1.4.2.3.1.4.2.2.1.3.2l34.1 19.7 149.3 86.2s.1 0 .1.1c.1.1.3.2.4.3s.3.2.4.3.3.2.4.3.3.2.4.3c.2.1.3.2.4.4.2.1.3.3.5.4l.4.4.4.4.4.4.4.4c.1.1.3.3.4.5s.3.3.4.5c.2.2.3.4.4.6l.6.9c.3.4.5.8.8 1.2.2.3.3.6.5.9l.3.6c.1.2.2.4.3.5.1.2.2.3.2.5.1.2.1.3.2.5s.1.3.2.5.1.3.2.5.1.3.2.5.1.3.2.5l.2.5c0 .2.1.4.1.5 0 .2.1.4.1.5 0 .2.1.3.1.5s.1.3.1.5.1.3.1.5 0 .3.1.5v1c.2.1.2.2.2.4",
    style: {
      fill: "url(#hersteller_svg__SVGID_5_)"
    }
  }), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M617.4 336v1.2c0 .1 0 .2-.1.3 0 .1 0 .2-.1.3 0 .1 0 .2-.1.3 0 .1-.1.2-.1.3s-.1.2-.1.3-.1.2-.1.3-.1.2-.1.3-.1.1-.1.2l-.1.1-.3.3c-.1.1-.2.3-.4.4l-.1.1-.1-.1-.2-.1-1.1-.6-4.3-2.5-.5-.3-5-2.9-2-1.1-.3-.2-.9-.5-4.2-2.4-.5-.3-5-2.9-2-1.1-.3-.2-.8-.5-4.2-2.4-.5-.3-5-2.9-2.3-1.3-41-23.7-1-.6-4.4-2.5-.4-.2-4.9-2.8-2.2-1.3-1-.6-4.3-2.5-.4-.2-4.9-2.9-2.2-1.3-.9-.5-4.4-2.5-.4-.2-4.9-2.8-2.3-1.3-37.9-22.1-8.7-5v-13.2l20.1 11.6 32.9 19 9.2 5.3 3.7 2.1 9.2 5.3 3.7 2.1 9.3 5.4 44.9 25.9 8.9 5.2 4 2.3 6.9 4 2 1.1 4 2.3 1.5.9c3.7 2.3 6.8 7.5 6.8 11.9",
    className: "hersteller_svg__st20"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M593.9 319.4v1.5c0 .1 0 .2-.1.3 0 .1-.1.2-.1.3s-.1.2-.1.3-.1.2-.1.4c-.1.2-.1.3-.2.4-.3.5-.7.8-1.1 1.1l-4.9 2.9-.1.1s.1 0 .1-.1c.1 0 .1-.1.2-.1s.1-.1.1-.1c.2-.2.3-.4.5-.6.1-.1.2-.3.2-.4v-.1c0-.1.1-.2.1-.3s.1-.2.1-.3.1-.2.1-.3v-.1c0-.1 0-.2.1-.2v-2.7c0-.1 0-.2-.1-.3v-.7c0-.1 0-.2-.1-.2v-.3c0-.1-.1-.2-.1-.3s-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.1-.1-.2-.1-.1-.1-.2c-.1-.1-.1-.3-.2-.4-.1-.2-.2-.4-.3-.5l-.1-.1c-.1-.1-.2-.3-.2-.4-.1-.1-.1-.2-.1-.2-.1-.2-.3-.4-.4-.6-.1-.1-.2-.2-.3-.4-.1-.1-.2-.2-.2-.3-.1-.1-.2-.2-.2-.3-.1-.1-.2-.2-.2-.3l-.3-.3-.3-.3-.3-.3c-.1-.1-.2-.2-.3-.2-.1-.1-.2-.1-.2-.2-.1-.1-.1-.1-.2-.1 0 0-.1 0-.1-.1l-.2-.2c-.1 0-.1-.1-.2-.1h-.1c-.1-.1-.2-.1-.3-.2h-.1c-.1 0-.1-.1-.2-.1s-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.2-.1c-.1 0-.1 0-.2-.1h-.2c-.1 0-.2 0-.3-.1h-1.4c-.1 0-.2 0-.3.1h-.1c-.2.1-.3.1-.5.2l5.2-3 8.9 5.2c.1.1.1.3.2.4s.1.2.2.4c.1.1.1.2.2.3 0 .1.1.2.1.3s.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3v.3c0 .1.1.2.1.3s0 .2.1.3v.9c-.1 0-.1.1-.1.2",
    className: "hersteller_svg__st18"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M588.7 322.7v1c0 .2-.1.3-.1.5v.1c0 .1-.1.2-.1.3s-.1.2-.1.3-.1.2-.1.3v.1c-.1.2-.1.3-.2.4-.1.2-.3.4-.5.6 0 .1-.1.1-.1.1s-.1.1-.2.1l-.2.2h-.1c-1.1.7-2.7.6-4.5-.4-3.5-2-6.2-6.8-6.2-10.8 0-2 .7-3.4 1.9-4 .1-.1.3-.1.5-.2h.1c.1 0 .2-.1.3-.1h1.5c.1 0 .2 0 .3.1h.2c.1 0 .1 0 .2.1.1 0 .2.1.2.1.1 0 .2.1.3.1s.2.1.3.1.2.1.3.1.2.1.3.1.1.1.2.1h.1c.1.1.2.1.3.2h.1c.1.1.2.1.2.2l.2.2s.1 0 .1.1c.1 0 .1.1.2.1.1.1.2.1.2.2.1.1.2.2.3.2l.3.3.3.3.3.3c.1.1.2.2.2.3.1.1.2.2.2.3.1.1.2.2.2.3.1.1.2.2.3.4s.3.4.4.6l.2.2c.1.1.2.3.2.4l.1.1c.1.2.2.4.3.5s.1.3.2.4c0 .1.1.1.1.2s.1.1.1.2.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.4v.1c0 .1 0 .2.1.2 0 .1 0 .2.1.2v.2c0 .1.1.2.1.4v.1c0 .1 0 .2.1.3v1.1c-.3-.1-.3 0-.3.2",
    className: "hersteller_svg__st29"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M583.7 321.1v.7s0 .1-.1.1l-.1.1c-.1.1-.1.2-.2.2l-.1.1c-.5.4-1.2.4-2-.1-1.4-.8-2.6-2.8-2.6-4.4 0-.8.3-1.4.8-1.7h.9c.1 0 .1 0 .2.1.1 0 .1 0 .2.1s.3.1.4.2c.1 0 .1.1.2.1l.1.1.1.1.1.1.2.2.2.2.1.1.1.1.1.1.1.1c.1.1.1.2.2.2.1.1.1.2.2.3 0 .1.1.1.1.2s.1.1.1.2c0 0 0 .1.1.1 0 0 0 .1.1.1 0 0 0 .1.1.1 0 0 0 .1.1.1v1.2c.3.8.3.9.3.9",
    className: "hersteller_svg__st30"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M584.8 320.5v.7s0 .1-.1.1c0 .1-.1.1-.1.2-.1.2-.3.3-.4.4l-1 .6h.1l.1-.1.2-.2.1-.1s0-.1.1-.1v-2.1s0-.1-.1-.1c0 0 0-.1-.1-.1 0 0 0-.1-.1-.1 0 0 0-.1-.1-.1 0-.1-.1-.1-.1-.2s-.1-.1-.1-.2c-.1-.1-.1-.2-.2-.3s-.1-.2-.2-.2c0-.1-.1-.1-.1-.1l-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1s-.1 0-.1-.1c0 0-.1 0-.1-.1 0 0-.1 0-.1-.1 0 0-.1 0-.1-.1 0 0-.1 0-.1-.1h-1.3l1-.6c.1 0 .1-.1.2-.1h1.2s.1 0 .1.1c0 0 .1 0 .1.1 0 0 .1 0 .1.1 0 0 .1 0 .1.1 0 0 .1 0 .1.1l.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1c0 .1.1.1.1.1.1.1.1.2.2.2.1.1.1.2.2.3 0 .1.1.1.1.2l.1.1s0 .1.1.1c0 0 0 .1.1.1 0 0 0 .1.1.1v.1s0 .1.1.1v1.1c-.1.1-.1.2-.1.2",
    className: "hersteller_svg__st31"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M606.8 326.8v1.5c0 .1 0 .2-.1.3 0 .1-.1.2-.1.3s-.1.2-.1.3-.1.2-.1.4c-.1.2-.1.3-.2.4-.3.5-.7.8-1.1 1.1l-4.9 2.9-.2.1c.1-.1.1-.1.2-.1s.1-.1.2-.1.1-.1.1-.1c.2-.2.3-.4.5-.6.1-.1.2-.3.2-.4v-.1c0-.1.1-.2.1-.3s.1-.2.1-.3.1-.2.1-.3v-.1c0-.1 0-.2.1-.2v-2.7c0-.1 0-.2-.1-.3v-.7c0-.1 0-.2-.1-.2v-.3c0-.1-.1-.2-.1-.3s-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.1-.1-.2-.1-.1-.1-.2c-.1-.1-.1-.3-.2-.4-.1-.2-.2-.4-.3-.5l-.1-.1c-.1-.1-.2-.3-.2-.4-.1-.1-.1-.2-.1-.2-.1-.2-.3-.4-.4-.6-.1-.1-.2-.2-.3-.4-.1-.1-.2-.2-.2-.3-.1-.1-.2-.2-.2-.3-.1-.1-.2-.2-.2-.3l-.3-.3-.3-.3-.3-.3c-.1-.1-.2-.2-.3-.2-.1-.1-.2-.1-.2-.2-.1-.1-.1-.1-.2-.1 0 0-.1 0-.1-.1l-.2-.2c-.1 0-.1-.1-.2-.1h-.1c-.1-.1-.2-.1-.3-.2h-.1c-.1 0-.1-.1-.2-.1s-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.2-.1h-.4c-.1 0-.2 0-.3-.1h-1.4c-.1 0-.2 0-.3.1h-.1c-.2.1-.3.1-.5.2l2.7-1.6 2.5-1.5 8.9 5.1c.1.1.2.3.2.4.1.1.1.2.2.4.1.1.1.2.2.3 0 .1.1.2.1.3s.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3v.1c0 .1 0 .1.1.2 0 .1.1.2.1.3s0 .2.1.3v.9c-.2.1-.2.2-.2.3",
    className: "hersteller_svg__st18"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M601.6 330.1v1c0 .2-.1.3-.1.5v.1c0 .1-.1.2-.1.3s-.1.2-.1.3-.1.2-.1.3v.1c-.1.2-.1.3-.2.4-.1.2-.3.4-.5.6 0 .1-.1.1-.1.1-.1 0-.1.1-.2.1l-.2.2h-.1c-1.1.7-2.7.6-4.5-.4-3.5-2-6.2-6.8-6.2-10.8 0-2 .7-3.4 1.9-4 .1-.1.3-.1.5-.2h.1c.1 0 .2-.1.3-.1h1.5c.1 0 .2 0 .3.1h.2c.1 0 .1 0 .2.1.1 0 .2.1.2.1.1 0 .2.1.3.1s.2.1.3.1.2.1.3.1.2.1.3.1.1.1.2.1h.1c.1.1.2.1.3.2h.1c.1.1.2.1.2.2l.2.2s.1 0 .1.1c.1 0 .1.1.2.1.1.1.2.1.2.2.1.1.2.2.3.2l.3.3.3.3.3.3c.1.1.2.2.2.3.1.1.2.2.2.3.1.1.2.2.2.3.1.1.2.2.3.4s.3.4.4.6l.2.2c.1.1.2.3.2.4l.1.1c.1.2.2.4.3.5s.1.3.2.4c0 .1.1.1.1.2s.1.1.1.2.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.4v.1c0 .1 0 .2.1.2 0 .1 0 .2.1.2v.2c0 .1.1.2.1.4v.1c0 .1 0 .2.1.3v1.1c-.3 0-.3.1-.3.2",
    className: "hersteller_svg__st29"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M596.6 328.6v.7s0 .1-.1.1l-.1.1c-.1.1-.1.2-.2.2l-.1.1c-.5.4-1.2.4-2-.1-1.4-.8-2.6-2.8-2.6-4.4 0-.8.3-1.4.8-1.7h.9c.1 0 .1 0 .2.1.1 0 .1 0 .2.1s.3.1.4.2c.1 0 .1.1.2.1l.1.1.1.1.1.1.2.2.2.2.1.1.1.1.1.1.1.1c.1.1.1.2.2.2.1.1.1.2.2.3 0 .1.1.1.1.2s.1.1.1.2c0 0 0 .1.1.1 0 0 0 .1.1.1 0 0 0 .1.1.1 0 0 0 .1.1.1v1.2c.3.8.3.8.3.9",
    className: "hersteller_svg__st30"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M597.7 328v.7s0 .1-.1.1c0 .1-.1.1-.1.2-.1.2-.3.3-.4.4l-1 .6h.1l.1-.1.2-.2.1-.1s0-.1.1-.1v-2.1s0-.1-.1-.1c0 0 0-.1-.1-.1 0 0 0-.1-.1-.1 0 0 0-.1-.1-.1 0-.1-.1-.1-.1-.2s-.1-.1-.1-.2c-.1-.1-.1-.2-.2-.3s-.1-.2-.2-.2c0-.1-.1-.1-.1-.1l-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1s-.1 0-.1-.1c0 0-.1 0-.1-.1 0 0-.1 0-.1-.1 0 0-.1 0-.1-.1 0 0-.1 0-.1-.1h-1.3l1-.6c.1 0 .1-.1.2-.1h1.2s.1 0 .1.1c0 0 .1 0 .1.1 0 0 .1 0 .1.1 0 0 .1 0 .1.1 0 0 .1 0 .1.1l.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1c0 .1.1.1.1.1.1.1.1.2.2.2.1.1.1.2.2.3 0 .1.1.1.1.2l.1.1s0 .1.1.1c0 0 0 .1.1.1 0 0 0 .1.1.1v.1s0 .1.1.1v1.1c-.1.1-.1.1-.1.2",
    className: "hersteller_svg__st31"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M617.4 336v1.2c0 .1 0 .2-.1.3 0 .1 0 .2-.1.3 0 .1 0 .2-.1.3 0 .1-.1.2-.1.3s-.1.2-.1.3-.1.2-.1.3-.1.2-.1.3-.1.1-.1.2l-2.7 1.6-1 .6c.1-.1.2-.1.2-.2.1 0 .1-.1.2-.1s.1-.1.1-.1l.2-.2c.1-.1.2-.3.3-.4s.2-.3.2-.4v-.1c0-.1.1-.2.1-.3s.1-.2.1-.3.1-.2.1-.3v-.1c0-.1 0-.2.1-.2v-2.7c0-.1 0-.2-.1-.3v-.7c0-.1 0-.2-.1-.2v-.3c0-.1-.1-.2-.1-.3s-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.1-.1-.2-.1-.1-.1-.2c-.1-.1-.1-.3-.2-.4-.1-.2-.2-.4-.3-.5l-.1-.1c-.1-.1-.2-.3-.2-.4-.1-.1-.1-.2-.1-.2-.1-.2-.3-.4-.4-.6-.1-.1-.2-.2-.3-.4-.1-.1-.2-.2-.2-.3s-.2-.2-.2-.3c-.1-.1-.2-.2-.2-.3l-.3-.3-.3-.3-.3-.3c-.1-.1-.2-.2-.3-.2-.1-.1-.2-.1-.2-.2-.1-.1-.1-.1-.2-.1 0 0-.1 0-.1-.1l-.2-.2c-.1 0-.1-.1-.2-.1h-.1c-.1-.1-.2-.1-.3-.2h-.1c-.1 0-.1-.1-.2-.1s-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.2-.1h-.3c-.1 0-.2 0-.3-.1h-1.4c-.1 0-.2 0-.3.1h-.1c-.2.1-.3.1-.5.2l2.7-1.5 2.5-1.4 1.5.9c3.4 1.7 6.5 6.9 6.5 11.3",
    className: "hersteller_svg__st18"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M614.5 337.5v1c0 .2-.1.3-.1.5v.1c0 .1-.1.2-.1.3s-.1.2-.1.3-.1.2-.1.3v.1c-.1.2-.1.3-.2.4-.1.2-.3.4-.5.6 0 .1-.1.1-.1.1-.1 0-.1.1-.2.1l-.2.2h-.1c-1.1.7-2.7.6-4.5-.4-3.5-2-6.2-6.8-6.2-10.8 0-2 .7-3.4 1.9-4 .1-.1.3-.1.5-.2h.1c.1 0 .2-.1.3-.1h1.5c.1 0 .2 0 .3.1h.2c.1 0 .1 0 .2.1.1 0 .2.1.2.1.1 0 .2.1.3.1s.2.1.3.1.2.1.3.1.2.1.3.1.1.1.2.1h.1c.1.1.2.1.3.2h.1c.1.1.2.1.2.2l.2.2s.1 0 .1.1c.1 0 .1.1.2.1.1.1.2.1.2.2.1.1.2.2.3.2l.3.3.3.3.3.3c.1.1.2.2.2.3.1.1.2.2.2.3.1.1.2.2.2.3.1.1.2.2.3.4s.3.4.4.6l.2.2c.1.1.2.3.2.4l.1.1c.1.2.2.4.3.5s.1.3.2.4c0 .1.1.1.1.2s.1.1.1.2.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.4v.1c0 .1 0 .2.1.2 0 .1 0 .2.1.2v.2c0 .1.1.2.1.4v.1c0 .1 0 .2.1.3v1.1c-.3 0-.3.1-.3.2",
    className: "hersteller_svg__st29"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M609.6 336v.7s0 .1-.1.1l-.1.1c-.1.1-.1.2-.2.2l-.1.1c-.5.4-1.2.4-2-.1-1.4-.8-2.6-2.8-2.6-4.4 0-.8.3-1.4.8-1.7h.9c.1 0 .1 0 .2.1.1 0 .1 0 .2.1s.3.1.4.2c.1 0 .1.1.2.1l.1.1.1.1.1.1.2.2.2.2.1.1.1.1.1.1.1.1c.1.1.1.2.2.2.1.1.1.2.2.3 0 .1.1.1.1.2s.1.1.1.2c0 0 0 .1.1.1 0 0 0 .1.1.1 0 0 0 .1.1.1 0 0 0 .1.1.1v1.2c.3.8.3.9.3.9",
    className: "hersteller_svg__st30"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M610.6 335.4v.7s0 .1-.1.1c0 .1-.1.1-.1.2-.1.2-.3.3-.4.4l-1 .6h.1l.1-.1.2-.2.1-.1s0-.1.1-.1v-2.1s0-.1-.1-.1c0 0 0-.1-.1-.1 0 0 0-.1-.1-.1 0 0 0-.1-.1-.1 0-.1-.1-.1-.1-.2s-.1-.1-.1-.2c-.1-.1-.1-.2-.2-.3s-.1-.2-.2-.2c0-.1-.1-.1-.1-.1l-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1s-.1 0-.1-.1c0 0-.1 0-.1-.1 0 0-.1 0-.1-.1 0 0-.1 0-.1-.1 0 0-.1 0-.1-.1h-1.3l1-.6c.1 0 .1-.1.2-.1h1.2s.1 0 .1.1c0 0 .1 0 .1.1 0 0 .1 0 .1.1 0 0 .1 0 .1.1 0 0 .1 0 .1.1l.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1c0 .1.1.1.1.1.1.1.1.2.2.2.1.1.1.2.2.3 0 .1.1.1.1.2l.1.1s0 .1.1.1c0 0 0 .1.1.1 0 0 0 .1.1.1v.1s0 .1.1.1v1.1c-.1.1-.1.1-.1.2",
    className: "hersteller_svg__st31"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M514.1 273.1v1.5c0 .1 0 .2-.1.3 0 .1-.1.2-.1.3s-.1.2-.1.3-.1.2-.1.4c-.1.2-.1.3-.2.4-.3.5-.7.8-1.1 1.1l-5.1 2.9h-.1s.1 0 .1-.1l.2-.1c.1 0 .1-.1.2-.1s.1-.1.1-.1c.2-.2.3-.4.5-.6.1-.1.2-.3.2-.4v-.1c0-.1.1-.2.1-.3s.1-.2.1-.3.1-.2.1-.3v-.1c0-.1 0-.2.1-.2v-2.7c0-.1 0-.2-.1-.3v-.7c0-.1 0-.2-.1-.2v-.3c0-.1-.1-.2-.1-.3s-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.1-.1-.2-.1-.1-.1-.2c-.1-.1-.1-.3-.2-.4-.1-.2-.2-.4-.3-.5l-.1-.1c-.1-.1-.2-.3-.2-.4-.1-.1-.1-.2-.1-.2-.1-.2-.3-.4-.4-.6-.1-.1-.2-.2-.3-.4-.1-.1-.2-.2-.2-.3-.1-.1-.2-.2-.2-.3-.1-.1-.2-.2-.2-.3l-.3-.3-.3-.3-.3-.3c-.1-.1-.2-.2-.3-.2-.1-.1-.2-.1-.2-.2-.1-.1-.1-.1-.2-.1 0 0-.1 0-.1-.1l-.2-.2c-.1 0-.1-.1-.2-.1h-.1c-.1-.1-.2-.1-.3-.2h-.1c-.1 0-.1-.1-.2-.1s-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.2-.1c-.1 0-.1 0-.2-.1h-.2c-.1 0-.2 0-.3-.1h-1.4c-.1 0-.2 0-.3.1h-.1c-.2.1-.3.1-.5.2l5-2.9 9.2 5.3.1.1c.1.1.1.2.2.4.1.1.1.2.2.3 0 .1.1.2.1.3s.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3v.3c0 .1.1.2.1.3s0 .2.1.3 0 .2 0 .3v.6c-.1.3-.1.4-.1.5",
    className: "hersteller_svg__st18"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M508.9 276.4v1c0 .2-.1.3-.1.5v.1c0 .1-.1.2-.1.3s-.1.2-.1.3-.1.2-.1.3v.1c-.1.2-.1.3-.2.4-.1.2-.3.4-.5.6 0 .1-.1.1-.1.1-.1 0-.1.1-.2.1l-.2.2h-.1c-1.1.7-2.7.6-4.5-.4-3.5-2-6.2-6.8-6.2-10.8 0-2 .7-3.4 1.9-4 .1-.1.3-.1.5-.2h.1c.1 0 .2-.1.3-.1h1.5c.1 0 .2 0 .3.1h.2c.1 0 .1 0 .2.1.1 0 .2.1.2.1.1 0 .2.1.3.1s.2.1.3.1.2.1.3.1.2.1.3.1.1.1.2.1h.1c.1.1.2.1.3.2h.1c.1.1.2.1.2.2l.2.2s.1 0 .1.1c.1 0 .1.1.2.1.1.1.2.1.2.2.1.1.2.2.3.2l.3.3.3.3.3.3c.1.1.2.2.2.3.1.1.2.2.2.3.1.1.2.2.2.3.1.1.2.2.3.4s.3.4.4.6l.2.2c.1.1.2.3.2.4l.1.1c.1.2.2.4.3.5s.1.3.2.4c0 .1.1.1.1.2s.1.1.1.2.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.4v.1c0 .1 0 .2.1.2 0 .1 0 .2.1.2v.2c0 .1.1.2.1.4v.1c0 .1 0 .2.1.3s0 .2 0 .3v.8c-.3 0-.3.1-.3.2",
    className: "hersteller_svg__st29"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M503.9 274.9v.7s0 .1-.1.1l-.1.1c-.1.1-.1.2-.2.2l-.1.1c-.5.4-1.2.4-2-.1-1.4-.8-2.6-2.8-2.6-4.4 0-.8.3-1.4.8-1.7h.9c.1 0 .1 0 .2.1.1 0 .1 0 .2.1s.3.1.4.2c.1 0 .1.1.2.1l.1.1.1.1.1.1.2.2.2.2.1.1.1.1.1.1.1.1c.1.1.1.2.2.2.1.1.1.2.2.3 0 .1.1.1.1.2s.1.1.1.2c0 0 0 .1.1.1 0 0 0 .1.1.1 0 0 0 .1.1.1 0 0 0 .1.1.1v1.2c.3.8.3.8.3.9",
    className: "hersteller_svg__st30"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M505 274.3v.7s0 .1-.1.1c0 .1-.1.1-.1.2-.1.2-.3.3-.4.4l-1 .6h.1l.1-.1.2-.2.1-.1s0-.1.1-.1v-2.1s0-.1-.1-.1c0 0 0-.1-.1-.1 0 0 0-.1-.1-.1 0 0 0-.1-.1-.1 0-.1-.1-.1-.1-.2s-.1-.1-.1-.2c-.1-.1-.1-.2-.2-.3s-.1-.2-.2-.2c0-.1-.1-.1-.1-.1l-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1s-.1 0-.1-.1c0 0-.1 0-.1-.1 0 0-.1 0-.1-.1 0 0-.1 0-.1-.1 0 0-.1 0-.1-.1h-1.3l1-.6c.1 0 .1-.1.2-.1h1.2s.1 0 .1.1c0 0 .1 0 .1.1 0 0 .1 0 .1.1 0 0 .1 0 .1.1 0 0 .1 0 .1.1l.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1c0 .1.1.1.1.1.1.1.1.2.2.2.1.1.1.2.2.3 0 .1.1.1.1.2l.1.1s0 .1.1.1c0 0 0 .1.1.1 0 0 0 .1.1.1v.1s0 .1.1.1v1.1c-.1.1-.1.1-.1.2",
    className: "hersteller_svg__st31"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M527 280.6v1.5c0 .1 0 .2-.1.3 0 .1-.1.2-.1.3s-.1.2-.1.3-.1.2-.1.4c-.1.2-.1.3-.2.4-.3.5-.7.8-1.1 1.1l-5.1 2.9-.1.1s.1 0 .1-.1c.1 0 .1-.1.1-.1.1 0 .1-.1.2-.1s.1-.1.1-.1c.2-.2.3-.4.5-.6.1-.1.2-.3.2-.4v-.1c0-.1.1-.2.1-.3s.1-.2.1-.3.1-.2.1-.3v-.1c0-.1 0-.2.1-.2v-2.7c0-.1 0-.2-.1-.3v-.7c0-.1 0-.2-.1-.2v-.3c0-.1-.1-.2-.1-.3s-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.1-.1-.2-.1-.1-.1-.2c-.1-.1-.1-.3-.2-.4-.1-.2-.2-.4-.3-.5l-.1-.1c-.1-.1-.2-.3-.2-.4-.1-.1-.1-.2-.1-.2-.1-.2-.3-.4-.4-.6-.1-.1-.2-.2-.3-.4-.1-.1-.2-.2-.2-.3-.1-.1-.2-.2-.2-.3-.1-.1-.2-.2-.2-.3l-.3-.3-.3-.3-.3-.3c-.1-.1-.2-.2-.3-.2-.1-.1-.2-.1-.2-.2-.1-.1-.1-.1-.2-.1 0 0-.1 0-.1-.1l-.2-.2c-.1 0-.1-.1-.2-.1h-.1c-.1-.1-.2-.1-.3-.2h-.1c-.1 0-.1-.1-.2-.1s-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.2-.1h-.4c-.1 0-.2 0-.3-.1h-1.4c-.1 0-.2 0-.3.1h-.1c-.2.1-.3.1-.5.2l2.7-1.6 2.3-1.4 9.2 5.3c0 .1.1.1.1.2.1.1.1.2.2.4.1.1.1.2.2.3 0 .1.1.2.1.3s.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3v.1c0 .1 0 .1.1.2 0 .1.1.2.1.3s0 .2.1.3v.9c-.1.1-.1.2-.1.3",
    className: "hersteller_svg__st18"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M521.8 283.9v1c0 .2-.1.3-.1.5v.1c0 .1-.1.2-.1.3s-.1.2-.1.3-.1.2-.1.3v.1c-.1.2-.1.3-.2.4-.1.2-.3.4-.5.6 0 .1-.1.1-.1.1-.1 0-.1.1-.2.1l-.2.2h-.1c-1.1.7-2.7.6-4.5-.4-3.5-2-6.2-6.8-6.2-10.8 0-2 .7-3.4 1.9-4 .1-.1.3-.1.5-.2h.1c.1 0 .2-.1.3-.1h1.5c.1 0 .2 0 .3.1h.2c.1 0 .1 0 .2.1.1 0 .2.1.2.1.1 0 .2.1.3.1s.2.1.3.1.2.1.3.1.2.1.3.1.1.1.2.1h.1c.1.1.2.1.3.2h.1c.1.1.2.1.2.2l.2.2s.1 0 .1.1c.1 0 .1.1.2.1.1.1.2.1.2.2.1.1.2.2.3.2l.3.3.3.3.3.3c.1.1.2.2.2.3.1.1.2.2.2.3.1.1.2.2.2.3.1.1.2.2.3.4s.3.4.4.6l.2.2c.1.1.2.3.2.4l.1.1c.1.2.2.4.3.5s.1.3.2.4c0 .1.1.1.1.2s.1.1.1.2.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.4v.1c0 .1 0 .2.1.2 0 .1 0 .2.1.2v.2c0 .1.1.2.1.4v.1c0 .1 0 .2.1.3s0 .2 0 .3v.8c-.3-.1-.3 0-.3.2",
    className: "hersteller_svg__st29"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M516.8 282.3v.7s0 .1-.1.1-.1.1-.1.1c-.1.1-.1.2-.2.2l-.1.1c-.5.4-1.2.4-2-.1-1.4-.8-2.6-2.8-2.6-4.4 0-.8.3-1.4.8-1.7h.9c.1 0 .1 0 .2.1.1 0 .1 0 .2.1s.3.1.4.2c.1 0 .1.1.2.1l.1.1.1.1.1.1.2.2.2.2.1.1.1.1.1.1.1.1c.1.1.1.2.2.2.1.1.1.2.2.3 0 .1.1.1.1.2s.1.1.1.2c0 0 0 .1.1.1 0 0 0 .1.1.1 0 0 0 .1.1.1 0 0 0 .1.1.1v1.2z",
    className: "hersteller_svg__st30"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M517.9 281.7v.7s0 .1-.1.1c0 .1-.1.1-.1.2-.1.2-.3.3-.4.4l-1 .6h.1l.1-.1.2-.2.1-.1s0-.1.1-.1v-2.1s0-.1-.1-.1c0 0 0-.1-.1-.1 0 0 0-.1-.1-.1 0 0 0-.1-.1-.1 0-.1-.1-.1-.1-.2s-.1-.1-.1-.2c-.1-.1-.1-.2-.2-.3s-.1-.2-.2-.2c0-.1-.1-.1-.1-.1l-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1s-.1 0-.1-.1c0 0-.1 0-.1-.1 0 0-.1 0-.1-.1 0 0-.1 0-.1-.1 0 0-.1 0-.1-.1H513l1-.6c.1 0 .1-.1.2-.1h1.2s.1 0 .1.1c0 0 .1 0 .1.1 0 0 .1 0 .1.1 0 0 .1 0 .1.1 0 0 .1 0 .1.1l.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1c0 .1.1.1.1.1.1.1.1.2.2.2.1.1.1.2.2.3 0 .1.1.1.1.2l.1.1s0 .1.1.1c0 0 0 .1.1.1 0 0 0 .1.1.1v.1s0 .1.1.1v1.1c-.1.1-.1.2-.1.2",
    className: "hersteller_svg__st31"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M539.9 288v1.5c0 .1 0 .2-.1.3 0 .1-.1.2-.1.3s-.1.2-.1.3-.1.2-.1.4c-.1.2-.1.3-.2.4-.3.5-.7.8-1.1 1.1l-5.1 3c.1 0 .1-.1.2-.1s.1-.1.2-.1.1-.1.1-.1c.2-.2.3-.4.5-.6.1-.1.2-.3.2-.4v-.1c0-.1.1-.2.1-.3s.1-.2.1-.3.1-.2.1-.3v-.1c0-.1 0-.2.1-.2v-2.9c0-.1 0-.2-.1-.3v-.7c0-.1 0-.2-.1-.2v-.3c0-.1-.1-.2-.1-.3s-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.1-.1-.2-.1-.1-.1-.2c-.1-.1-.1-.3-.2-.4-.1-.2-.2-.4-.3-.5l-.1-.1c-.1-.1-.2-.3-.2-.4-.1-.1-.1-.2-.1-.2-.1-.2-.3-.4-.4-.6-.1-.1-.2-.2-.3-.4-.1-.1-.2-.2-.2-.3s-.2-.2-.2-.3c-.1-.1-.2-.2-.2-.3l-.3-.3-.3-.3-.3-.3c-.1-.1-.2-.2-.3-.2-.1-.1-.2-.1-.2-.2-.1-.1-.1-.1-.2-.1 0 0-.1 0-.1-.1l-.2-.2c-.1 0-.1-.1-.2-.1h-.1c-.1-.1-.2-.1-.3-.2h-.1c-.1 0-.1-.1-.2-.1s-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.3-.1-.2-.1-.2-.1h-.3c-.1 0-.2 0-.3-.1h-1.4c-.1 0-.2 0-.3.1h-.1c-.2.1-.3.1-.5.2l2.7-1.5 2.3-1.4 9.3 5.4v.1c.1.1.1.2.2.4.1.1.1.2.2.3 0 .1.1.2.1.3s.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3 0 .2.1.3v.9c-.3.1-.3.2-.3.3",
    className: "hersteller_svg__st18"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M534.7 291.3v1c0 .2-.1.3-.1.5v.1c0 .1-.1.2-.1.3s-.1.2-.1.3-.1.2-.1.3v.1c-.1.2-.1.3-.2.4-.1.2-.3.4-.5.6 0 .1-.1.1-.1.1-.1 0-.1.1-.2.1l-.2.2h-.1c-1.1.7-2.7.6-4.5-.4-3.5-2-6.2-6.8-6.2-10.8 0-2 .7-3.4 1.9-4 .1-.1.3-.1.5-.2h.1c.1 0 .2-.1.3-.1h1.5c.1 0 .2 0 .3.1h.2c.1 0 .1 0 .2.1.1 0 .2.1.2.1.1 0 .2.1.3.1s.2.1.3.1.2.1.3.1.2.1.3.1.1.1.2.1h.1c.1.1.2.1.3.2h.1c.1.1.2.1.2.2l.2.2s.1 0 .1.1c.1 0 .1.1.2.1.1.1.2.1.2.2.1.1.2.2.3.2l.3.3.3.3.3.3c.1.1.2.2.2.3.1.1.2.2.2.3.1.1.2.2.2.3.1.1.2.2.3.4s.3.4.4.6l.2.2c.1.1.2.3.2.4l.1.1c.1.2.2.4.3.5s.1.3.2.4c0 .1.1.1.1.2s.1.1.1.2.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.3.1.2.1.4v.1c0 .1 0 .2.1.2 0 .1 0 .2.1.2v.2c0 .1.1.2.1.4v.1c0 .1 0 .2.1.3v1.1c-.3-.1-.3.1-.3.2",
    className: "hersteller_svg__st29"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M529.7 289.7v.7s0 .1-.1.1l-.1.1c-.1.1-.1.2-.2.2l-.1.1c-.5.4-1.2.4-2-.1-1.4-.8-2.6-2.8-2.6-4.4 0-.8.3-1.4.8-1.7h.9c.1 0 .1 0 .2.1.1 0 .1 0 .2.1s.3.1.4.2c.1 0 .1.1.2.1l.1.1.1.1.1.1.2.2.2.2.1.1.1.1.1.1.1.1c.1.1.1.2.2.2.1.1.1.2.2.3 0 .1.1.1.1.2s.1.1.1.2c0 0 0 .1.1.1 0 0 0 .1.1.1 0 0 0 .1.1.1 0 0 0 .1.1.1v1.2z",
    className: "hersteller_svg__st30"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M530.8 289.1v.7s0 .1-.1.1c0 .1-.1.1-.1.2-.1.2-.3.3-.4.4l-1 .6h.1l.1-.1.2-.2.1-.1s0-.1.1-.1v-2.1s0-.1-.1-.1c0 0 0-.1-.1-.1 0 0 0-.1-.1-.1 0 0 0-.1-.1-.1 0-.1-.1-.1-.1-.2s-.1-.1-.1-.2c-.1-.1-.1-.2-.2-.3s-.1-.2-.2-.2c0-.1-.1-.1-.1-.1l-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1-.1s-.1 0-.1-.1c0 0-.1 0-.1-.1 0 0-.1 0-.1-.1 0 0-.1 0-.1-.1 0 0-.1 0-.1-.1h-1.3l1-.6c.1 0 .1-.1.2-.1h1.2s.1 0 .1.1c0 0 .1 0 .1.1 0 0 .1 0 .1.1 0 0 .1 0 .1.1 0 0 .1 0 .1.1l.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1.1c0 .1.1.1.1.1.1.1.1.2.2.2.1.1.1.2.2.3 0 .1.1.1.1.2l.1.1s0 .1.1.1c0 0 0 .1.1.1 0 0 0 .1.1.1v.1s0 .1.1.1v1.1z",
    className: "hersteller_svg__st31"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M404.4 154.5v18.3l-37.9-21.9.1-18.3z",
    className: "hersteller_svg__st29"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "m404.4 154.5 1.1-.6-.1 18.3-1 .6z",
    className: "hersteller_svg__st17"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "m366.6 132.6 1-.6 37.9 21.9-1.1.6z",
    className: "hersteller_svg__st2"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M403.6 164v5.1l-2.2 1.3c0-.2-.3-2.2 2.2-6.4",
    className: "hersteller_svg__st17"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M403.6 164c-.2.4-.4.7-.5 1s-.3.5-.4.8c-.1.2-.2.5-.3.7l-.3.6c-.1.2-.2.4-.2.6-.1.2-.1.4-.2.6s-.1.4-.1.6-.1.4-.1.6c-.1.6 0 .8 0 .9L366.4 150v-.9c0-.2.1-.4.1-.6s.1-.4.1-.6c.1-.2.1-.4.2-.6s.1-.4.2-.6l.3-.6c.1-.2.2-.5.3-.7.1-.3.3-.5.4-.8.2-.3.3-.6.5-.9v-.1z",
    className: "hersteller_svg__st2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M403.6 169.1v-7.8l-35.1-17.7 1.1 3.5z",
    style: {
      opacity: 0.15,
      fill: "#505e5f"
    }
  }), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M403.6 156.2v5.1l-2.2 1.3c0-.1-.3-2.2 2.2-6.4",
    className: "hersteller_svg__st17"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M403.6 156.2q0 .15 0 0c-.2.4-.4.7-.5 1s-.3.5-.4.8c-.1.2-.2.5-.3.7l-.3.6c-.1.2-.2.4-.2.6-.1.2-.1.4-.2.6s-.1.4-.1.6-.1.4-.1.6c-.1.6 0 .8 0 .9l-35.1-20.4v-.9c0-.2.1-.4.1-.6s.1-.4.1-.6c.1-.2.1-.4.2-.6s.1-.4.2-.6l.3-.6c.1-.2.2-.5.3-.7.1-.3.3-.5.4-.8.2-.3.3-.6.5-.9v-.1z",
    className: "hersteller_svg__st2"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M581.4 171c.9 2.6-.2 5.4-2.5 6.1-2.3.8-3.7-1.8-4.5-4.5-.9-2.6-.4-7 1.9-6.1 1.2.5 4.2 1.8 5.1 4.5",
    className: "hersteller_svg__st10"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hersteller_svg__SVGID_6_",
    x1: 487.25,
    x2: 513.978,
    y1: 363.28,
    y2: 307.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m392.1 299.3 57.6-33.5 164.5 95-57.6 33.5z",
    style: {
      opacity: 0.2,
      fill: "url(#hersteller_svg__SVGID_6_)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hersteller_svg__SVGID_7_",
    x1: 290.681,
    x2: 362.894,
    y1: 392.134,
    y2: 316.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m332.8 321.4 6-3.5 23 13.3-6 3.5zm29.8 17.2 6-3.5 23.1 13.3-6 3.5zm37.2 13-66.6-38.4-1.3.8-6 3.5-1.5.9.8.5-78.2 45.3 65 37.5 78.2-45.5.8.5 1.3-.8.2-.1 6-3.5.2-.1z",
    style: {
      fill: "url(#hersteller_svg__SVGID_7_)"
    }
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m323.2 110.7-.1 33.6-.3 108.4-.1 40.3v16.1l-21.1 12.3v-16.3l.1-39 .4-134v-9.2z",
    className: "hersteller_svg__st22"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M302.1 122.9v9.2l-.4 134-.1 39v16.3l-14.1-8.1-.1-.1.1-38 .4-144.2-29.2-16.8-98.1-56.7-21.1-12.1-.4 144.7-14.2 9 .5-178.2 28.2 16.3 7 4z",
    className: "hersteller_svg__st19"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "m323.2 110.7-21.1 12.2-141.5-81.7-7-4-28.2-16.3 21.1-12.2z",
    className: "hersteller_svg__st2"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "m258.7 114.2-98.5 62.5-.1.1V57.3l.5.2z",
    className: "hersteller_svg__st20"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "m287.9 131-.4 144.2-71.6 45.4L68.5 235l56.4-35.9 14.2-9 21.1-13.4 98.5-62.5z",
    className: "hersteller_svg__st2"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "m287.5 313.3-140.1 80.9 68.5-73.6 71.6-45.4-.1 38z",
    className: "hersteller_svg__st22"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "m215.9 320.6-68.5 73.6L0 308.5 68.5 235z",
    className: "hersteller_svg__st19"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M160.5 57.5v119.1l-21.4 13.5.4-144.7z",
    className: "hersteller_svg__st22"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "m125.1 125.8 14.1 17.2v11.1L125 136.9z",
    className: "hersteller_svg__st11"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "m139.2 143 21.1-12.3v11.2l-21.1 12.2z",
    className: "hersteller_svg__st36"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "m125.2 91.8 14.1 17.2v11.2L125.1 103z",
    className: "hersteller_svg__st11"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "m139.3 109 21.1-12.3v11.2l-21.1 12.3z",
    className: "hersteller_svg__st36"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M125.3 57.8 139.4 75v11.2L125.2 69z",
    className: "hersteller_svg__st11"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "m139.4 75 21.1-12.3v11.2l-21.1 12.3z",
    className: "hersteller_svg__st36"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "m287.6 219.7 14.2 17.2-.1 11.1-14.1-17.2z",
    className: "hersteller_svg__st11"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "m301.8 236.9 21.1-12.3v11.2L301.7 248z",
    className: "hersteller_svg__st12"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "m287.7 185.7 14.2 17.2-.1 11.2-14.1-17.3z",
    className: "hersteller_svg__st11"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "m301.9 202.9 21.1-12.3-.1 11.2-21.1 12.3z",
    className: "hersteller_svg__st12"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "m287.8 151.7 14.2 17.2-.1 11.2-14.1-17.2z",
    className: "hersteller_svg__st11"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "m302 168.9 21.1-12.3-.1 11.2-21.1 12.3z",
    className: "hersteller_svg__st12"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "m216.9 199-66.3 38.5-6.4-3.7 66.3-38.5z",
    className: "hersteller_svg__st9"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M216.9 199v1.6l-66.3 38.5v-1.6z",
    className: "hersteller_svg__st37"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M150.6 237.5v1.6l-6.4-3.7v-1.6z",
    className: "hersteller_svg__st38"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "m238.5 211.4-66.2 38.5-6.4-3.6 66.2-38.5z",
    className: "hersteller_svg__st9"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M238.5 211.4v1.7l-66.3 38.5.1-1.7z",
    className: "hersteller_svg__st37"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "m172.3 249.9-.1 1.7-6.3-3.7v-1.6z",
    className: "hersteller_svg__st38"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "m260.1 223.9-66.2 38.5-6.4-3.6 66.3-38.5z",
    className: "hersteller_svg__st9"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M260.1 223.9v1.7l-66.2 38.5v-1.7z",
    className: "hersteller_svg__st37"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M193.9 262.4v1.7l-6.4-3.7v-1.6z",
    className: "hersteller_svg__st38"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "m200.7 250.5-6.8 4-6.4-3.7 6.8-4z",
    className: "hersteller_svg__st9"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M200.7 250.5v8.2l-6.8 3.9v-8.1z",
    className: "hersteller_svg__st37"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M193.9 254.5v8.1l-6.4-3.7v-8.1z",
    className: "hersteller_svg__st38"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "m179 238-6.7 4-6.4-3.7 6.8-4z",
    className: "hersteller_svg__st9"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M179 238v8.2l-6.8 3.9.1-8.1z",
    className: "hersteller_svg__st37"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "m172.3 242-.1 8.1-6.3-3.7v-8.1z",
    className: "hersteller_svg__st38"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "m157.4 225.5-6.8 4-6.4-3.7 6.8-4z",
    className: "hersteller_svg__st9"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M157.4 225.5v8.2l-6.8 3.9v-8.1z",
    className: "hersteller_svg__st37"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M150.6 229.5v8.1l-6.4-3.7v-8.1z",
    className: "hersteller_svg__st38"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "m260.2 216-6.8 3.9-6.4-3.7 6.8-3.9z",
    className: "hersteller_svg__st9"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "m260.2 216-.1 8.1-6.8 3.9.1-8.1z",
    className: "hersteller_svg__st37"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "m253.4 219.9-.1 8.1-6.3-3.6v-8.2z",
    className: "hersteller_svg__st38"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "m238.5 203.5-6.8 3.9-6.4-3.7 6.8-3.9z",
    className: "hersteller_svg__st9"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M238.5 203.5v8.1l-6.8 4v-8.2z",
    className: "hersteller_svg__st37"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M231.7 207.4v8.2l-6.4-3.7v-8.2z",
    className: "hersteller_svg__st38"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "m216.9 191-6.8 3.9-6.4-3.7 6.8-3.9z",
    className: "hersteller_svg__st9"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "m216.9 191-.1 8.1-6.7 4v-8.2z",
    className: "hersteller_svg__st37"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M210.1 194.9v8.2l-6.4-3.7v-8.2z",
    className: "hersteller_svg__st38"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "m230.4 233.2-6.8 4-6.3-3.7 6.7-3.9z",
    className: "hersteller_svg__st9"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M230.4 233.2v8.2l-6.8 3.9v-8.1z",
    className: "hersteller_svg__st37"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M223.6 237.2v8.1l-6.4-3.7.1-8.1z",
    className: "hersteller_svg__st38"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "m208.8 220.7-6.8 4-6.4-3.7 6.8-3.9z",
    className: "hersteller_svg__st9"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "m208.8 220.7-.1 8.2-6.7 3.9v-8.1z",
    className: "hersteller_svg__st37"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M202 224.7v8.1l-6.4-3.7V221z",
    className: "hersteller_svg__st38"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "m187.1 208.2-6.7 4-6.4-3.7 6.8-3.9z",
    className: "hersteller_svg__st9"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M187.1 208.2v8.2l-6.8 3.9.1-8.1z",
    className: "hersteller_svg__st37"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "m180.4 212.2-.1 8.1-6.4-3.6.1-8.2z",
    className: "hersteller_svg__st38"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "m260.1 214.3-6.7 3.9-49.7-28.7 6.8-3.9z",
    className: "hersteller_svg__st37"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M260.1 214.3v1.6l-6.7 3.9v-1.6z",
    className: "hersteller_svg__st37"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M253.4 218.2v1.6l-49.7-28.6v-1.7z",
    className: "hersteller_svg__st38"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "m230.4 231.5-6.8 4-49.6-28.7 6.7-3.9z",
    className: "hersteller_svg__st37"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M230.4 231.5v1.7l-6.8 3.9v-1.6z",
    className: "hersteller_svg__st37"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M223.6 235.5v1.6L174 208.4v-1.6z",
    className: "hersteller_svg__st38"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "m200.7 248.8-6.8 4-49.7-28.7 6.8-3.9z",
    className: "hersteller_svg__st37"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M200.7 248.8v1.7l-6.8 3.9v-1.6z",
    className: "hersteller_svg__st37"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M193.9 252.8v1.6l-49.7-28.7v-1.6z",
    className: "hersteller_svg__st38"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M218.7 188.5 152.5 227l-8.3-4.8 66.3-38.5z",
    className: "hersteller_svg__st39"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M218.7 188.5v1.7l-66.2 38.5V227z",
    className: "hersteller_svg__st40"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M152.5 227v1.7l-8.3-4.8v-1.7z",
    className: "hersteller_svg__st9"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M229.1 194.5 162.8 233l-8.2-4.8 66.2-38.5z",
    className: "hersteller_svg__st39"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M229.1 194.5v1.6l-66.3 38.5V233z",
    className: "hersteller_svg__st40"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M162.8 233v1.6l-8.2-4.7v-1.7z",
    className: "hersteller_svg__st9"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M239.4 200.5 173.2 239l-8.3-4.8 66.3-38.5z",
    className: "hersteller_svg__st39"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M239.4 200.5v1.6l-66.2 38.5V239z",
    className: "hersteller_svg__st40"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M173.2 239v1.6l-8.3-4.8v-1.6z",
    className: "hersteller_svg__st9"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "m249.8 206.4-66.3 38.5-8.3-4.7 66.3-38.5z",
    className: "hersteller_svg__st39"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M249.8 206.4v1.7l-66.3 38.5v-1.7z",
    className: "hersteller_svg__st40"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M183.5 244.9v1.7l-8.3-4.8v-1.6z",
    className: "hersteller_svg__st9"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "m260.1 212.4-66.2 38.5-8.3-4.8 66.3-38.5z",
    className: "hersteller_svg__st39"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M260.1 212.4v1.6l-66.2 38.6v-1.7z",
    className: "hersteller_svg__st40"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M193.9 250.9v1.7l-8.3-4.8v-1.7z",
    className: "hersteller_svg__st9"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "m233.8 169.3-31.7 18.4-23.4-13.5 31.7-18.5z",
    className: "hersteller_svg__st41"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "m233.8 169.3-.1 28.5-31.7 18.4.1-28.5z",
    className: "hersteller_svg__st10"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "m202.1 187.7-.1 28.5-23.4-13.5.1-28.5z",
    className: "hersteller_svg__st9"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "m223.4 163.3-31.7 18.4-2.6-1.5 31.7-18.4z",
    className: "hersteller_svg__st9"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M191.7 181.7v5.1l-2.7-1.5.1-5.1z",
    className: "hersteller_svg__st42"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M229.3 182.7c.4-.2.7-.1.7.3l1 8.5c0 .4-.2 1-.6 1.3l-13.9 9.9s-.1 0-.1.1c-.4.2-.7.1-.7-.3l-1-8.5c0-.4.2-1 .6-1.3zc0 .1 0 0 0 0",
    className: "hersteller_svg__st2"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M189.5 201.1c.4.2.8.6 1 1.2.1.2.2.8.4 1l.2-.1c.3-.1.5-.4.9-.4.2 0 .4 0 .7.2.2.1.4.3.5.5.2.3.5.6.6 1 .1.3.3.9.5 1.1.3.2.8-.5 1.1-.6.2 0 .4 0 .7.2.2.1.4.3.6.5.4.5.7 1.1.9 1.6.2.4.5 1.1.9 1.3h.2c.5.3.7 1.3.2 1.1-.1 0-.2-.1-.2-.1-1-.6-1.4-1.8-2.1-3-.2-.3-.3-.4-.4-.5s-.3-.1-.4 0c-.3.2-.6.7-1.2.4-.1 0-.1 0-.2-.1-.5-.3-.8-.9-1.1-1.5-.2-.4-.3-.9-.6-1.1-.1 0-.1-.1-.2 0-.5.1-.8.8-1.5.4-.1 0-.2-.1-.2-.2-.5-.5-.6-1.2-1-1.8l-.3-.3c-.1-.1-.2-.1-.4-.1-.3 0-.4.3-.3.7 0 .3-.2.4-.4.3s-.4-.4-.5-.8c-.1-.8.3-1.4 1-1.3.2.2.4.3.6.4",
    className: "hersteller_svg__st42"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "m258.2 183.5-31.7 18.4-23.4-13.5 31.7-18.4z",
    className: "hersteller_svg__st41"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M258.2 183.5V212l-31.8 18.5.1-28.6z",
    className: "hersteller_svg__st10"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "m226.5 201.9-.1 28.6-23.4-13.6.1-28.5zM247.8 177.5l-31.7 18.4-2.6-1.5 31.7-18.4z",
    className: "hersteller_svg__st9"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M216.1 196v5l-2.6-1.5v-5z",
    className: "hersteller_svg__st42"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M253.8 197c.4-.2.7-.1.7.3l1 8.5c0 .4-.2 1-.6 1.3L241 217s-.1 0-.1.1c-.4.2-.7.1-.7-.3l-1-8.5c0-.4.2-1 .6-1.3zc-.1 0 0 0 0 0",
    className: "hersteller_svg__st2"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M214 215.3c.4.2.8.6 1 1.2.1.2.2.8.4 1l.2-.1c.3-.1.5-.4.9-.4.2 0 .4 0 .7.2.2.1.4.3.5.5.2.3.5.6.6 1 .1.3.3.9.5 1.1.3.2.8-.5 1.1-.6.2 0 .4 0 .7.2.2.1.4.3.6.5.4.5.7 1.1.9 1.6.2.4.5 1.1.9 1.3h.2c.5.3.7 1.3.2 1.1-.1 0-.2-.1-.2-.1-1-.6-1.4-1.8-2.1-3-.2-.3-.3-.4-.4-.5s-.3-.1-.4 0c-.3.2-.6.7-1.2.4-.1 0-.1 0-.2-.1-.5-.3-.8-.9-1.1-1.5-.2-.4-.3-.9-.6-1.1-.1 0-.1-.1-.2 0-.5.1-.8.8-1.5.4-.1 0-.2-.1-.2-.2-.5-.5-.6-1.2-1-1.8l-.3-.3c-.1-.1-.2-.1-.4-.1-.3 0-.4.3-.3.7 0 .3-.2.4-.4.3s-.4-.4-.5-.8c-.1-.8.3-1.4 1-1.3.2.2.4.3.6.4",
    className: "hersteller_svg__st42"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "m201.3 188.1-31.7 18.5-23.4-13.6 31.7-18.4z",
    className: "hersteller_svg__st41"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "m201.3 188.1-.1 28.6-31.7 18.4.1-28.5z",
    className: "hersteller_svg__st10"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "m169.6 206.6-.1 28.5-23.4-13.5.1-28.6z",
    className: "hersteller_svg__st9"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "m190.9 182.1-31.7 18.5-2.6-1.5 31.7-18.5z",
    className: "hersteller_svg__st9"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "m159.2 200.6-.1 5.1-2.6-1.5.1-5.1z",
    className: "hersteller_svg__st42"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M196.8 201.6c.4-.2.7-.1.7.3l1 8.5c0 .4-.2 1-.6 1.3l-13.9 9.9s-.1 0-.1.1c-.4.2-.7.1-.7-.3l-1-8.5c0-.4.2-1 .6-1.3z",
    className: "hersteller_svg__st2"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M157 220c.4.2.8.6 1 1.2.1.2.2.8.4 1l.2-.1c.3-.1.5-.4.9-.4.2 0 .4 0 .7.2.2.1.4.3.5.5.2.3.5.6.6 1 .1.3.3.9.5 1.1.3.2.8-.5 1.1-.6.2 0 .4 0 .7.2.2.1.4.3.6.5.4.5.7 1.1.9 1.6.2.4.5 1.1.9 1.3h.2c.5.3.7 1.3.2 1.1-.1 0-.2-.1-.2-.1-1-.6-1.4-1.8-2.1-3-.2-.3-.3-.4-.4-.5s-.3-.1-.4 0c-.3.2-.6.7-1.2.4-.1 0-.1 0-.2-.1-.5-.3-.8-.9-1.1-1.5-.2-.4-.3-.9-.6-1.1-.1 0-.1-.1-.2 0-.5.1-.8.8-1.5.4-.1 0-.2-.1-.2-.2-.5-.5-.6-1.2-1-1.8l-.3-.3c-.1-.1-.2-.1-.4-.1-.3 0-.4.3-.3.7 0 .3-.2.4-.4.3s-.4-.4-.5-.8c-.1-.8.3-1.4 1-1.3.2.2.4.2.6.4",
    className: "hersteller_svg__st42"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "m225.8 202.4-31.7 18.4-23.4-13.5 31.7-18.5z",
    className: "hersteller_svg__st41"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "m225.8 202.4-.1 28.5-31.7 18.4.1-28.5z",
    className: "hersteller_svg__st10"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "m194.1 220.8-.1 28.5-23.4-13.5.1-28.5zM215.4 196.4l-31.7 18.4-2.6-1.5 31.7-18.4z",
    className: "hersteller_svg__st9"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M183.7 214.8v5.1l-2.6-1.5v-5.1z",
    className: "hersteller_svg__st42"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M221.3 215.8c.4-.2.7-.1.7.3l1 8.5c0 .4-.2 1-.6 1.3l-13.9 9.9s-.1 0-.1.1c-.4.2-.7.1-.7-.3l-1-8.5c0-.4.2-1 .6-1.3zc0 .1 0 0 0 0",
    className: "hersteller_svg__st2"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M181.5 234.2c.4.2.8.6 1 1.2.1.2.2.8.4 1l.2-.1c.3-.1.5-.4.9-.4.2 0 .4 0 .7.2.2.1.4.3.5.5.2.3.5.6.6 1 .1.3.3.9.5 1.1.3.2.8-.5 1.1-.6.2 0 .4 0 .7.2.2.1.4.3.6.5.4.5.7 1.1.9 1.6.2.4.5 1.1.9 1.3h.2c.5.3.7 1.3.2 1.1-.1 0-.2-.1-.2-.1-1-.6-1.4-1.8-2.1-3-.2-.3-.3-.4-.4-.5s-.3-.1-.4 0c-.3.2-.6.7-1.2.4-.1 0-.1 0-.2-.1-.5-.3-.8-.9-1.1-1.5-.2-.4-.3-.9-.6-1.1-.1 0-.1-.1-.2 0-.5.1-.8.8-1.5.4-.1 0-.2-.1-.2-.2-.5-.5-.6-1.2-1-1.8l-.3-.3c-.1-.1-.2-.1-.4-.1-.3 0-.4.3-.3.7 0 .3-.2.4-.4.3s-.4-.4-.5-.8c-.1-.8.3-1.4 1-1.3.2.2.4.3.6.4",
    className: "hersteller_svg__st42"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "m233.8 140.3-31.7 18.4-23.4-13.5 31.7-18.4z",
    className: "hersteller_svg__st41"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "m233.8 140.3-.1 28.5-31.7 18.5.1-28.6z",
    className: "hersteller_svg__st10"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "m202.1 158.7-.1 28.6-23.4-13.6.1-28.5z",
    className: "hersteller_svg__st9"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "m223.4 134.3-31.7 18.4-2.6-1.5 31.7-18.4z",
    className: "hersteller_svg__st9"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M191.7 152.8v5.1l-2.7-1.5.1-5.1z",
    className: "hersteller_svg__st42"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M229.3 153.8c.4-.2.7-.1.7.3l1 8.5c0 .4-.2 1-.6 1.3l-13.9 9.9s-.1 0-.1.1c-.4.2-.7.1-.7-.3l-1-8.5c0-.4.2-1 .6-1.3z",
    className: "hersteller_svg__st2"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M189.5 172.1c.4.2.8.6 1 1.2.1.2.2.8.4 1l.2-.1c.3-.1.5-.4.9-.4.2 0 .4 0 .7.2.2.1.4.3.5.5.2.3.5.6.6 1 .1.3.3.9.5 1.1.3.2.8-.5 1.1-.6.2 0 .4 0 .7.2.2.1.4.3.6.5.4.5.7 1.1.9 1.6.2.4.5 1.1.9 1.3h.2c.5.3.7 1.3.2 1.1-.1 0-.2-.1-.2-.1-1-.6-1.4-1.8-2.1-3-.2-.3-.3-.4-.4-.5s-.3-.1-.4 0c-.3.2-.6.7-1.2.4-.1 0-.1 0-.2-.1-.5-.3-.8-.9-1.1-1.5-.2-.4-.3-.9-.6-1.1-.1 0-.1-.1-.2 0-.5.1-.8.8-1.5.4-.1 0-.2-.1-.2-.2-.5-.5-.6-1.2-1-1.8l-.3-.3c-.1-.1-.2-.1-.4-.1-.3 0-.4.3-.3.7 0 .3-.2.4-.4.3s-.4-.4-.5-.8c-.1-.8.3-1.4 1-1.3.2.2.4.3.6.4",
    className: "hersteller_svg__st42"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M258.2 154.5 226.5 173l-23.4-13.6 31.7-18.4z",
    className: "hersteller_svg__st41"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M258.2 154.5v28.6l-31.8 18.4.1-28.5z",
    className: "hersteller_svg__st10"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "m226.5 173-.1 28.5L203 188l.1-28.6z",
    className: "hersteller_svg__st9"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M247.8 148.5 216.1 167l-2.6-1.5 31.7-18.5z",
    className: "hersteller_svg__st9"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M216.1 167v5.1l-2.6-1.5v-5.1z",
    className: "hersteller_svg__st42"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M253.8 168c.4-.2.7-.1.7.3l1 8.5c0 .4-.2 1-.6 1.3L241 188s-.1 0-.1.1c-.4.2-.7.1-.7-.3l-1-8.5c0-.4.2-1 .6-1.3zc-.1 0 0 0 0 0",
    className: "hersteller_svg__st2"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M214 186.4c.4.2.8.6 1 1.2.1.2.2.8.4 1l.2-.1c.3-.1.5-.4.9-.4.2 0 .4 0 .7.2.2.1.4.3.5.5.2.3.5.6.6 1 .1.3.3.9.5 1.1.3.2.8-.5 1.1-.6.2 0 .4 0 .7.2.2.1.4.3.6.5.4.5.7 1.1.9 1.6.2.4.5 1.1.9 1.3h.2c.5.3.7 1.3.2 1.1-.1 0-.2-.1-.2-.1-1-.6-1.4-1.8-2.1-3-.2-.3-.3-.4-.4-.5s-.3-.1-.4 0c-.3.2-.6.7-1.2.4-.1 0-.1 0-.2-.1-.5-.3-.8-.9-1.1-1.5-.2-.4-.3-.9-.6-1.1-.1 0-.1-.1-.2 0-.5.1-.8.8-1.5.4-.1 0-.2-.1-.2-.2-.5-.5-.6-1.2-1-1.8l-.3-.3c-.1-.1-.2-.1-.4-.1-.3 0-.4.3-.3.7 0 .3-.2.4-.4.3s-.4-.4-.5-.8c-.1-.8.3-1.4 1-1.3.2.2.4.2.6.4",
    className: "hersteller_svg__st42"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "m201.3 159.2-31.7 18.4-23.4-13.5 31.7-18.4z",
    className: "hersteller_svg__st41"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "m201.3 159.2-.1 28.5-31.7 18.4.1-28.5z",
    className: "hersteller_svg__st10"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "m169.6 177.6-.1 28.5-23.4-13.5.1-28.5zM190.9 153.2l-31.7 18.4-2.6-1.5 31.7-18.4z",
    className: "hersteller_svg__st9"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "m159.2 171.6-.1 5.1-2.6-1.5.1-5.1z",
    className: "hersteller_svg__st42"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M196.8 172.6c.4-.2.7-.1.7.3l1 8.5c0 .4-.2 1-.6 1.3l-13.9 9.9s-.1 0-.1.1c-.4.2-.7.1-.7-.3l-1-8.5c0-.4.2-1 .6-1.3zq0 .15 0 0",
    className: "hersteller_svg__st2"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M157 191c.4.2.8.6 1 1.2.1.2.2.8.4 1l.2-.1c.3-.1.5-.4.9-.4.2 0 .4 0 .7.2.2.1.4.3.5.5.2.3.5.6.6 1 .1.3.3.9.5 1.1.3.2.8-.5 1.1-.6.2 0 .4 0 .7.2.2.1.4.3.6.5.4.5.7 1.1.9 1.6.2.4.5 1.1.9 1.3h.2c.5.3.7 1.3.2 1.1-.1 0-.2-.1-.2-.1-1-.6-1.4-1.8-2.1-3-.2-.3-.3-.4-.4-.5s-.3-.1-.4 0c-.3.2-.6.7-1.2.4-.1 0-.1 0-.2-.1-.5-.3-.8-.9-1.1-1.5-.2-.4-.3-.9-.6-1.1-.1 0-.1-.1-.2 0-.5.1-.8.8-1.5.4-.1 0-.2-.1-.2-.2-.5-.5-.6-1.2-1-1.8l-.3-.3c-.1-.1-.2-.1-.4-.1-.3 0-.4.3-.3.7 0 .3-.2.4-.4.3s-.4-.4-.5-.8c-.1-.8.3-1.4 1-1.3.2.2.4.3.6.4",
    className: "hersteller_svg__st42"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "m225.8 173.4-31.7 18.4-23.4-13.5 31.7-18.4z",
    className: "hersteller_svg__st41"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "m225.8 173.4-.1 28.5-31.7 18.5.1-28.6z",
    className: "hersteller_svg__st10"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "m194.1 191.8-.1 28.6-23.4-13.6.1-28.5zM215.4 167.4l-31.7 18.4-2.6-1.5 31.7-18.4z",
    className: "hersteller_svg__st9"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M183.7 185.9v5.1l-2.6-1.5v-5.1z",
    className: "hersteller_svg__st42"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M221.3 186.9c.4-.2.7-.1.7.3l1 8.5c0 .4-.2 1-.6 1.3l-13.9 9.9s-.1 0-.1.1c-.4.2-.7.1-.7-.3l-1-8.5c0-.4.2-1 .6-1.3z",
    className: "hersteller_svg__st2"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M181.5 205.2c.4.2.8.6 1 1.2.1.2.2.8.4 1l.2-.1c.3-.1.5-.4.9-.4.2 0 .4 0 .7.2.2.1.4.3.5.5.2.3.5.6.6 1 .1.3.3.9.5 1.1.3.2.8-.5 1.1-.6.2 0 .4 0 .7.2.2.1.4.3.6.5.4.5.7 1.1.9 1.6.2.4.5 1.1.9 1.3h.2c.5.3.7 1.3.2 1.1-.1 0-.2-.1-.2-.1-1-.6-1.4-1.8-2.1-3-.2-.3-.3-.4-.4-.5s-.3-.1-.4 0c-.3.2-.6.7-1.2.4-.1 0-.1 0-.2-.1-.5-.3-.8-.9-1.1-1.5-.2-.4-.3-.9-.6-1.1-.1 0-.1-.1-.2 0-.5.1-.8.8-1.5.4-.1 0-.2-.1-.2-.2-.5-.5-.6-1.2-1-1.8l-.3-.3c-.1-.1-.2-.1-.4-.1-.3 0-.4.3-.3.7 0 .3-.2.4-.4.3s-.4-.4-.5-.8c-.1-.8.3-1.4 1-1.3.2.2.4.3.6.4",
    className: "hersteller_svg__st42"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "m376.6 286.7 66.2 38.5 6.4-3.7L383 283z",
    className: "hersteller_svg__st9"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M376.6 286.7v1.6l66.2 38.5v-1.6z",
    className: "hersteller_svg__st38"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M442.8 325.2v1.6l6.4-3.7v-1.6z",
    className: "hersteller_svg__st37"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "m354.9 299.1 66.3 38.5 6.4-3.6-66.3-38.5z",
    className: "hersteller_svg__st9"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M354.9 299.1v1.7l66.3 38.5v-1.7z",
    className: "hersteller_svg__st38"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M421.2 337.6v1.7l6.4-3.7V334z",
    className: "hersteller_svg__st37"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "m333.3 311.6 66.2 38.5 6.4-3.6-66.2-38.5z",
    className: "hersteller_svg__st9"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M333.3 311.6v1.7l66.2 38.5v-1.7z",
    className: "hersteller_svg__st38"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M399.5 350.1v1.7l6.4-3.7v-1.6z",
    className: "hersteller_svg__st37"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "m392.7 338.2 6.8 4 6.4-3.7-6.8-4z",
    className: "hersteller_svg__st9"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "m392.7 338.2.1 8.2 6.8 3.9-.1-8.1z",
    className: "hersteller_svg__st38"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "m399.5 342.2.1 8.1 6.3-3.7v-8.1z",
    className: "hersteller_svg__st37"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "m414.4 325.7 6.8 4 6.4-3.7-6.8-4z",
    className: "hersteller_svg__st9"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M414.4 325.7v8.2l6.8 3.9v-8.1z",
    className: "hersteller_svg__st38"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M421.2 329.7v8.1l6.4-3.7V326z",
    className: "hersteller_svg__st37"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "m436 313.2 6.8 4 6.4-3.7-6.8-4z",
    className: "hersteller_svg__st9"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "m436 313.2.1 8.2 6.7 3.9v-8.1z",
    className: "hersteller_svg__st38"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M442.8 317.2v8.1l6.4-3.7v-8.1z",
    className: "hersteller_svg__st37"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "m333.3 303.7 6.8 3.9 6.3-3.7-6.7-3.9z",
    className: "hersteller_svg__st9"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M333.3 303.7v8.1l6.8 3.9v-8.1z",
    className: "hersteller_svg__st38"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M340.1 307.6v8.1l6.4-3.6-.1-8.2z",
    className: "hersteller_svg__st37"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "m354.9 291.2 6.8 3.9 6.4-3.7-6.8-3.9z",
    className: "hersteller_svg__st9"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M354.9 291.2v8.1l6.8 3.9v-8.1z",
    className: "hersteller_svg__st37"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M361.7 295.1v8.1l6.4-3.6v-8.2z",
    className: "hersteller_svg__st38"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "m376.6 278.7 6.7 3.9 6.4-3.7-6.8-3.9z",
    className: "hersteller_svg__st9"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M376.6 278.7v8.1l6.8 4-.1-8.2z",
    className: "hersteller_svg__st37"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "m383.3 282.6.1 8.2 6.4-3.7-.1-8.2z",
    className: "hersteller_svg__st38"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "m363 320.9 6.8 4 6.4-3.7-6.8-4z",
    className: "hersteller_svg__st9"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M363 320.9v8.2l6.8 3.9v-8.1z",
    className: "hersteller_svg__st38"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M369.8 324.9v8.1l6.4-3.7v-8.1z",
    className: "hersteller_svg__st37"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "m384.7 308.4 6.7 4 6.4-3.7-6.8-3.9z",
    className: "hersteller_svg__st9"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M384.7 308.4v8.2l6.8 3.9-.1-8.1z",
    className: "hersteller_svg__st37"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "m391.4 312.4.1 8.1 6.4-3.7-.1-8.1z",
    className: "hersteller_svg__st38"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "m406.3 295.9 6.8 4 6.4-3.7-6.8-3.9z",
    className: "hersteller_svg__st9"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M406.3 295.9v8.2l6.8 3.9v-8.1z",
    className: "hersteller_svg__st37"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M413.1 299.9v8.1l6.4-3.6v-8.2z",
    className: "hersteller_svg__st38"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "m333.3 302 6.8 3.9 49.6-28.7-6.7-3.9z",
    className: "hersteller_svg__st37"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M333.3 302v1.6l6.8 3.9v-1.6zM340.1 305.9v1.6l49.6-28.6v-1.7z",
    className: "hersteller_svg__st38"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "m363 319.2 6.8 4 49.7-28.7-6.8-3.9z",
    className: "hersteller_svg__st37"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M363 319.2v1.7l6.8 3.9v-1.6zM369.8 323.2v1.6l49.7-28.7v-1.6z",
    className: "hersteller_svg__st38"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m392.8 336.5 6.7 4 49.7-28.7-6.8-4z",
    style: {
      fill: "#ba9e8c"
    }
  }), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M392.8 336.5v1.7l6.7 3.9v-1.6z",
    className: "hersteller_svg__st38"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M399.5 340.5v1.6l49.7-28.7v-1.6z",
    className: "hersteller_svg__st37"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "m374.7 276.2 66.2 38.5 8.3-4.8-66.2-38.5z",
    className: "hersteller_svg__st39"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M374.7 276.2v1.7l66.3 38.5-.1-1.7z",
    className: "hersteller_svg__st40"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "m440.9 314.7.1 1.7 8.2-4.8v-1.7z",
    className: "hersteller_svg__st9"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "m364.4 282.2 66.2 38.5 8.3-4.8-66.3-38.5z",
    className: "hersteller_svg__st39"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M364.4 282.2v1.6l66.2 38.5v-1.6z",
    className: "hersteller_svg__st40"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M430.6 320.7v1.6l8.3-4.8v-1.6z",
    className: "hersteller_svg__st9"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "m354 288.2 66.3 38.5 8.2-4.8-66.2-38.5z",
    className: "hersteller_svg__st39"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M354 288.2v1.6l66.3 38.5v-1.6z",
    className: "hersteller_svg__st40"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M420.3 326.7v1.6l8.2-4.8v-1.6z",
    className: "hersteller_svg__st9"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "m343.7 294.1 66.2 38.5 8.3-4.7-66.3-38.5z",
    className: "hersteller_svg__st39"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M343.7 294.1v1.7l66.2 38.5v-1.7z",
    className: "hersteller_svg__st40"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M409.9 332.6v1.7l8.3-4.8v-1.6z",
    className: "hersteller_svg__st9"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "m333.3 300.1 66.3 38.5 8.2-4.8-66.2-38.5z",
    className: "hersteller_svg__st39"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M333.3 300.1v1.6l66.3 38.5v-1.6z",
    className: "hersteller_svg__st40"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M399.6 338.6v1.6l8.2-4.7v-1.7z",
    className: "hersteller_svg__st9"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "m359.6 257 31.8 18.4 23.4-13.5-31.7-18.5z",
    className: "hersteller_svg__st41"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "m359.6 257 .1 28.5 31.7 18.4v-28.5z",
    className: "hersteller_svg__st10"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M391.4 275.4v28.5l23.5-13.5-.1-28.5z",
    className: "hersteller_svg__st9"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "m370.1 251 31.7 18.4 2.6-1.5-31.7-18.4z",
    className: "hersteller_svg__st9"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M401.8 269.4v5.1l2.6-1.5v-5.1z",
    className: "hersteller_svg__st42"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M364.1 270.4c-.4-.2-.7-.1-.7.3l-1 8.5c0 .4.2 1 .6 1.3l13.9 9.9s.1 0 .1.1c.4.2.7.1.7-.3l1-8.5c0-.4-.2-1-.6-1.3zc.1.1 0 0 0 0",
    className: "hersteller_svg__st2"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M403.9 288.8c-.4.2-.8.6-1 1.2-.1.2-.2.8-.4 1l-.2-.1c-.3-.1-.5-.4-.9-.4-.2 0-.4 0-.7.2-.2.1-.4.3-.5.5-.2.3-.5.6-.6 1-.1.3-.3.9-.5 1.1-.3.2-.8-.5-1.1-.6-.2 0-.4 0-.7.2-.2.1-.4.3-.6.5-.4.5-.7 1.1-.9 1.6-.2.4-.5 1.1-.9 1.3h-.2c-.5.3-.7 1.3-.2 1.1.1 0 .2-.1.2-.1 1-.6 1.4-1.8 2.1-3 .2-.3.3-.4.4-.5s.3-.1.4 0c.3.2.6.7 1.2.4.1 0 .1 0 .2-.1.5-.3.8-.9 1.1-1.5.2-.4.3-.9.6-1.1.1 0 .1-.1.2 0 .5.1.8.8 1.5.4.1 0 .2-.1.2-.2.5-.5.6-1.2 1-1.8l.3-.3c.1-.1.2-.1.4-.1.3 0 .4.3.3.7 0 .3.2.4.4.3s.4-.4.5-.8c.1-.8-.3-1.4-1-1.3-.2.2-.4.3-.6.4",
    className: "hersteller_svg__st42"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "m335.2 271.2 31.7 18.4 23.4-13.5-31.7-18.4z",
    className: "hersteller_svg__st41"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "m335.2 271.2.1 28.5 31.7 18.5-.1-28.6z",
    className: "hersteller_svg__st9"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "m366.9 289.6.1 28.6 23.4-13.6-.1-28.5z",
    className: "hersteller_svg__st10"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "m345.6 265.2 31.7 18.4 2.6-1.5-31.7-18.4z",
    className: "hersteller_svg__st9"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M377.3 283.7v5l2.6-1.5v-5.1z",
    className: "hersteller_svg__st42"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M339.6 284.7c-.4-.2-.7-.1-.7.3l-1 8.5c0 .4.2 1 .6 1.3l13.9 9.9s.1 0 .1.1c.4.2.7.1.7-.3l1-8.5c0-.4-.2-1-.6-1.3zq.15 0 0 0",
    className: "hersteller_svg__st2"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M379.5 303c-.4.2-.8.6-1 1.2-.1.2-.2.8-.4 1l-.2-.1c-.3-.1-.5-.4-.9-.4-.2 0-.4 0-.7.2-.2.1-.4.3-.5.5-.2.3-.5.6-.6 1-.1.3-.3.9-.5 1.1-.3.2-.8-.5-1.1-.6-.2 0-.4 0-.7.2-.2.1-.4.3-.6.5-.4.5-.7 1.1-.9 1.6-.2.4-.5 1.1-.9 1.3h-.2c-.5.3-.7 1.3-.2 1.1.1 0 .2-.1.2-.1 1-.6 1.4-1.8 2.1-3 .2-.3.3-.4.4-.5s.3-.1.4 0c.3.2.6.7 1.2.4.1 0 .1 0 .2-.1.5-.3.8-.9 1.1-1.5.2-.4.3-.9.6-1.1.1 0 .1-.1.2 0 .5.1.8.8 1.5.4.1 0 .2-.1.2-.2.5-.5.6-1.2 1-1.8l.3-.3c.1-.1.2-.1.4-.1.3 0 .4.3.3.7 0 .3.2.4.4.3s.4-.4.5-.8c.1-.8-.3-1.4-1-1.3-.2.2-.4.3-.6.4",
    className: "hersteller_svg__st42"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "m392.1 275.8 31.8 18.5 23.4-13.6-31.7-18.4z",
    className: "hersteller_svg__st41"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "m392.1 275.8.1 28.6 31.7 18.4v-28.5z",
    className: "hersteller_svg__st9"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M423.9 294.3v28.5l23.5-13.5-.1-28.6z",
    className: "hersteller_svg__st10"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "m402.6 269.8 31.7 18.5 2.6-1.5-31.7-18.5z",
    className: "hersteller_svg__st9"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M434.3 288.3v5.1l2.6-1.5v-5.1z",
    className: "hersteller_svg__st42"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M396.6 289.3c-.4-.2-.7-.1-.7.3l-1 8.5c0 .4.2 1 .6 1.3l13.9 9.9s.1 0 .1.1c.4.2.7.1.7-.3l1-8.5c0-.4-.2-1-.6-1.3zc.1 0 0 0 0 0",
    className: "hersteller_svg__st2"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M436.4 307.7c-.4.2-.8.6-1 1.2-.1.2-.2.8-.4 1l-.2-.1c-.3-.1-.5-.4-.9-.4-.2 0-.4 0-.7.2-.2.1-.4.3-.5.5-.2.3-.5.6-.6 1-.1.3-.3.9-.5 1.1-.3.2-.8-.5-1.1-.6-.2 0-.4 0-.7.2-.2.1-.4.3-.6.5-.4.5-.7 1.1-.9 1.6-.2.4-.5 1.1-.9 1.3h-.2c-.5.3-.7 1.3-.2 1.1.1 0 .2-.1.2-.1 1-.6 1.4-1.8 2.1-3 .2-.3.3-.4.4-.5s.3-.1.4 0c.3.2.6.7 1.2.4.1 0 .1 0 .2-.1.5-.3.8-.9 1.1-1.5.2-.4.3-.9.6-1.1.1 0 .1-.1.2 0 .5.1.8.8 1.5.4.1 0 .2-.1.2-.2.5-.5.6-1.2 1-1.8l.3-.3c.1-.1.2-.1.4-.1.3 0 .4.3.3.7 0 .3.2.4.4.3s.4-.4.5-.8c.1-.8-.3-1.4-1-1.3-.2.2-.4.2-.6.4",
    className: "hersteller_svg__st42"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "m367.6 290.1 31.7 18.4 23.5-13.5-31.8-18.5z",
    className: "hersteller_svg__st41"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "m367.6 290.1.1 28.5 31.7 18.4-.1-28.5z",
    className: "hersteller_svg__st9"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "m399.3 308.5.1 28.5 23.4-13.5V295z",
    className: "hersteller_svg__st10"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "m378 284.1 31.8 18.4 2.6-1.5-31.8-18.4z",
    className: "hersteller_svg__st9"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M409.8 302.5v5.1l2.6-1.5V301z",
    className: "hersteller_svg__st42"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M372.1 303.5c-.4-.2-.7-.1-.7.3l-1 8.5c0 .4.2 1 .6 1.3l13.9 9.9s.1 0 .1.1c.4.2.7.1.7-.3l1-8.5c0-.4-.2-1-.6-1.3zc0 .1 0 0 0 0",
    className: "hersteller_svg__st2"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M411.9 321.9c-.4.2-.8.6-1 1.2-.1.2-.2.8-.4 1l-.2-.1c-.3-.1-.5-.4-.9-.4-.2 0-.4 0-.7.2-.2.1-.4.3-.5.5-.2.3-.5.6-.6 1-.1.3-.3.9-.5 1.1-.3.2-.8-.5-1.1-.6-.2 0-.4 0-.7.2-.2.1-.4.3-.6.5-.4.5-.7 1.1-.9 1.6-.2.4-.5 1.1-.9 1.3h-.2c-.5.3-.7 1.3-.2 1.1.1 0 .2-.1.2-.1 1-.6 1.4-1.8 2.1-3 .2-.3.3-.4.4-.5s.3-.1.4 0c.3.2.6.7 1.2.4.1 0 .1 0 .2-.1.5-.3.8-.9 1.1-1.5.2-.4.3-.9.6-1.1.1 0 .1-.1.2 0 .5.1.8.8 1.5.4.1 0 .2-.1.2-.2.5-.5.6-1.2 1-1.8l.3-.3c.1-.1.2-.1.4-.1.3 0 .4.3.3.7 0 .3.2.4.4.3s.4-.4.5-.8c.1-.8-.3-1.4-1-1.3-.2.2-.4.3-.6.4",
    className: "hersteller_svg__st42"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "m359.6 228 31.8 18.4 23.4-13.5-31.7-18.4z",
    className: "hersteller_svg__st41"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "m359.6 228 .1 28.5 31.7 18.5v-28.6z",
    className: "hersteller_svg__st9"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M391.4 246.4V275l23.5-13.6-.1-28.5z",
    className: "hersteller_svg__st10"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "m370.1 222 31.7 18.4 2.6-1.5-31.7-18.4z",
    className: "hersteller_svg__st9"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M401.8 240.5v5.1l2.6-1.5V239z",
    className: "hersteller_svg__st42"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M364.1 241.5c-.4-.2-.7-.1-.7.3l-1 8.5c0 .4.2 1 .6 1.3l13.9 9.9s.1 0 .1.1c.4.2.7.1.7-.3l1-8.5c0-.4-.2-1-.6-1.3zc.1 0 0 0 0 0",
    className: "hersteller_svg__st2"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M403.9 259.8c-.4.2-.8.6-1 1.2-.1.2-.2.8-.4 1l-.2-.1c-.3-.1-.5-.4-.9-.4-.2 0-.4 0-.7.2-.2.1-.4.3-.5.5-.2.3-.5.6-.6 1-.1.3-.3.9-.5 1.1-.3.2-.8-.5-1.1-.6-.2 0-.4 0-.7.2-.2.1-.4.3-.6.5-.4.5-.7 1.1-.9 1.6-.2.4-.5 1.1-.9 1.3h-.2c-.5.3-.7 1.3-.2 1.1.1 0 .2-.1.2-.1 1-.6 1.4-1.8 2.1-3 .2-.3.3-.4.4-.5s.3-.1.4 0c.3.2.6.7 1.2.4.1 0 .1 0 .2-.1.5-.3.8-.9 1.1-1.5.2-.4.3-.9.6-1.1.1 0 .1-.1.2 0 .5.1.8.8 1.5.4.1 0 .2-.1.2-.2.5-.5.6-1.2 1-1.8l.3-.3c.1-.1.2-.1.4-.1.3 0 .4.3.3.7 0 .3.2.4.4.3s.4-.4.5-.8c.1-.8-.3-1.4-1-1.3-.2.2-.4.3-.6.4",
    className: "hersteller_svg__st42"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "m335.2 242.2 31.7 18.5 23.4-13.6-31.7-18.4z",
    className: "hersteller_svg__st41"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "m335.2 242.2.1 28.6 31.7 18.4-.1-28.5z",
    className: "hersteller_svg__st9"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "m366.9 260.7.1 28.5 23.4-13.5-.1-28.6z",
    className: "hersteller_svg__st10"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "m345.6 236.2 31.7 18.5 2.6-1.5-31.7-18.5z",
    className: "hersteller_svg__st9"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M377.3 254.7v5.1l2.6-1.5v-5.1z",
    className: "hersteller_svg__st42"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M339.6 255.7c-.4-.2-.7-.1-.7.3l-1 8.5c0 .4.2 1 .6 1.3l13.9 9.9s.1 0 .1.1c.4.2.7.1.7-.3l1-8.5c0-.4-.2-1-.6-1.3zq.15 0 0 0",
    className: "hersteller_svg__st2"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M379.5 274.1c-.4.2-.8.6-1 1.2-.1.2-.2.8-.4 1l-.2-.1c-.3-.1-.5-.4-.9-.4-.2 0-.4 0-.7.2-.2.1-.4.3-.5.5-.2.3-.5.6-.6 1-.1.3-.3.9-.5 1.1-.3.2-.8-.5-1.1-.6-.2 0-.4 0-.7.2-.2.1-.4.3-.6.5-.4.5-.7 1.1-.9 1.6-.2.4-.5 1.1-.9 1.3h-.2c-.5.3-.7 1.3-.2 1.1.1 0 .2-.1.2-.1 1-.6 1.4-1.8 2.1-3 .2-.3.3-.4.4-.5s.3-.1.4 0c.3.2.6.7 1.2.4.1 0 .1 0 .2-.1.5-.3.8-.9 1.1-1.5.2-.4.3-.9.6-1.1.1 0 .1-.1.2 0 .5.1.8.8 1.5.4.1 0 .2-.1.2-.2.5-.5.6-1.2 1-1.8l.3-.3c.1-.1.2-.1.4-.1.3 0 .4.3.3.7 0 .3.2.4.4.3s.4-.4.5-.8c.1-.8-.3-1.4-1-1.3-.2.2-.4.2-.6.4",
    className: "hersteller_svg__st42"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "m392.1 246.9 31.8 18.4 23.4-13.5-31.7-18.5z",
    className: "hersteller_svg__st41"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "m392.1 246.9.1 28.5 31.7 18.4v-28.5z",
    className: "hersteller_svg__st9"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M423.9 265.3v28.5l23.5-13.5-.1-28.5z",
    className: "hersteller_svg__st10"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "m402.6 240.9 31.7 18.4 2.6-1.5-31.7-18.4z",
    className: "hersteller_svg__st9"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M434.3 259.3v5.1l2.6-1.5v-5.1z",
    className: "hersteller_svg__st42"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M396.6 260.3c-.4-.2-.7-.1-.7.3l-1 8.5c0 .4.2 1 .6 1.3l13.9 9.9s.1 0 .1.1c.4.2.7.1.7-.3l1-8.5c0-.4-.2-1-.6-1.3zc.1.1 0 0 0 0",
    className: "hersteller_svg__st2"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M436.4 278.7c-.4.2-.8.6-1 1.2-.1.2-.2.8-.4 1l-.2-.1c-.3-.1-.5-.4-.9-.4-.2 0-.4 0-.7.2-.2.1-.4.3-.5.5-.2.3-.5.6-.6 1-.1.3-.3.9-.5 1.1-.3.2-.8-.5-1.1-.6-.2 0-.4 0-.7.2-.2.1-.4.3-.6.5-.4.5-.7 1.1-.9 1.6-.2.4-.5 1.1-.9 1.3h-.2c-.5.3-.7 1.3-.2 1.1.1 0 .2-.1.2-.1 1-.6 1.4-1.8 2.1-3 .2-.3.3-.4.4-.5s.3-.1.4 0c.3.2.6.7 1.2.4.1 0 .1 0 .2-.1.5-.3.8-.9 1.1-1.5.2-.4.3-.9.6-1.1.1 0 .1-.1.2 0 .5.1.8.8 1.5.4.1 0 .2-.1.2-.2.5-.5.6-1.2 1-1.8l.3-.3c.1-.1.2-.1.4-.1.3 0 .4.3.3.7 0 .3.2.4.4.3s.4-.4.5-.8c.1-.8-.3-1.4-1-1.3-.2.2-.4.3-.6.4",
    className: "hersteller_svg__st42"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "m367.6 261.1 31.7 18.4 23.5-13.5-31.8-18.4z",
    className: "hersteller_svg__st41"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "m367.6 261.1.1 28.5 31.7 18.5-.1-28.6z",
    className: "hersteller_svg__st9"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "m399.3 279.5.1 28.6 23.4-13.6V266z",
    className: "hersteller_svg__st10"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "m378 255.1 31.8 18.4 2.6-1.5-31.8-18.4z",
    className: "hersteller_svg__st9"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M409.8 273.6v5.1l2.6-1.5v-5.1z",
    className: "hersteller_svg__st42"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M372.1 274.6c-.4-.2-.7-.1-.7.3l-1 8.5c0 .4.2 1 .6 1.3l13.9 9.9s.1 0 .1.1c.4.2.7.1.7-.3l1-8.5c0-.4-.2-1-.6-1.3z",
    className: "hersteller_svg__st2"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M411.9 292.9c-.4.2-.8.6-1 1.2-.1.2-.2.8-.4 1l-.2-.1c-.3-.1-.5-.4-.9-.4-.2 0-.4 0-.7.2-.2.1-.4.3-.5.5-.2.3-.5.6-.6 1-.1.3-.3.9-.5 1.1-.3.2-.8-.5-1.1-.6-.2 0-.4 0-.7.2-.2.1-.4.3-.6.5-.4.5-.7 1.1-.9 1.6-.2.4-.5 1.1-.9 1.3h-.2c-.5.3-.7 1.3-.2 1.1.1 0 .2-.1.2-.1 1-.6 1.4-1.8 2.1-3 .2-.3.3-.4.4-.5s.3-.1.4 0c.3.2.6.7 1.2.4.1 0 .1 0 .2-.1.5-.3.8-.9 1.1-1.5.2-.4.3-.9.6-1.1.1 0 .1-.1.2 0 .5.1.8.8 1.5.4.1 0 .2-.1.2-.2.5-.5.6-1.2 1-1.8l.3-.3c.1-.1.2-.1.4-.1.3 0 .4.3.3.7 0 .3.2.4.4.3s.4-.4.5-.8c.1-.8-.3-1.4-1-1.3-.2.2-.4.3-.6.4",
    className: "hersteller_svg__st42"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "m539.1 216.8-21 12.2-28.8-16.7 21-12.2z",
    className: "hersteller_svg__st41"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M539.1 216.8v25.7l-21 12.2V229z",
    className: "hersteller_svg__st10"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M518.1 229v25.7l-28.9-16.6.1-25.8zM529.7 222.2l-2 1.2-28.8-16.6 2-1.2z",
    className: "hersteller_svg__st9"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M529.7 222.2v6.8l-2 1.1v-6.7z",
    className: "hersteller_svg__st42"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M494.1 227.4s.1 0 .1.1l8.9 6.3c.5.4.9 1.2.9 1.7l-.7 5.8c-.1.5-.5.7-1 .4 0 0-.1 0-.1-.1l-8.9-6.3c-.5-.4-.9-1.2-.9-1.7l.7-5.8c.1-.5.5-.7 1-.4",
    className: "hersteller_svg__st2"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M525.4 243.7c.4-.3.8-.4 1.1-.2.2.1.3.3.5.4 0 0 .3-.1.2 0 .1-.1.1-.2.2-.3.4-.5.8-1.1 1.2-1.4.1-.1.2-.2.3-.2.5-.3.9-.1 1.3-.1.4.1.2 1.1-.1 1.4-.1.1-.1.1-.2.1-.3 0-.7-.2-1.1 0l-.1.1c-.4.3-.8.9-1.1 1.4l-.2.2c-.3.3-.6.3-.9.2s-.5-.7-1-.3l-.1.1c-.3.3-.5 1-.7 1.4s-.5.8-.8 1.1c-.1.1-.2.1-.3.2-.4.2-.6.1-1 0-.1 0-.2-.1-.3 0-.1.2-.1.5-.1.7 0 .4-.2.6-.3.8-.2.2-.5.1-.5-.4.1-.8.2-1.7.7-2.2l.1-.1c.4-.3.7-.2 1-.1.2 0 .4.1.6-.1.1-.1.2-.2.3-.4.3-.6.5-1.3.9-1.8.1-.3.3-.5.4-.5",
    className: "hersteller_svg__st42"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "m594.9 248.9-21 12.2-28.9-16.7 21-12.2z",
    className: "hersteller_svg__st41"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "m594.9 248.9-.1 25.7-21 12.2.1-25.7z",
    className: "hersteller_svg__st10"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "m573.9 261.1-.1 25.7-28.8-16.6v-25.8zM585.4 254.3l-2 1.2-28.8-16.6 2-1.2z",
    className: "hersteller_svg__st9"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M585.5 254.3v6.8l-2.1 1.1v-6.7z",
    className: "hersteller_svg__st42"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M549.8 259.5s.1 0 .1.1l8.9 6.3c.5.4.9 1.2.9 1.7l-.7 5.8c-.1.5-.5.7-1 .4 0 0-.1 0-.1-.1l-8.9-6.3c-.5-.4-.9-1.2-.9-1.7l.7-5.8c.1-.5.5-.7 1-.4",
    className: "hersteller_svg__st2"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M581.1 275.8c.4-.3.8-.4 1.1-.2.2.1.3.3.5.4 0 0 .3-.1.2 0 .1-.1.1-.2.2-.3.4-.5.8-1.1 1.2-1.4.1-.1.2-.2.3-.2.5-.3.9-.1 1.3-.1.4.1.2 1.1-.1 1.4-.1.1-.1.1-.2.1-.3 0-.7-.2-1.1 0l-.1.1c-.4.3-.8.9-1.1 1.4l-.2.2c-.3.3-.6.3-.9.2s-.5-.7-1-.3l-.1.1c-.3.3-.5 1-.7 1.4s-.5.8-.8 1.1c-.1.1-.2.1-.3.2-.4.2-.6.1-1 0-.1 0-.2-.1-.3 0-.1.2-.1.5-.1.7 0 .4-.2.6-.3.8-.2.2-.5.1-.5-.4.1-.8.2-1.7.7-2.2l.1-.1c.4-.3.7-.2 1-.1.2 0 .4.1.6-.1.1-.1.2-.2.3-.4.3-.6.5-1.3.9-1.8.2-.3.3-.5.4-.5",
    className: "hersteller_svg__st42"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hersteller_svg__SVGID_8_",
    x1: 150.895,
    x2: 287.366,
    y1: 213.03,
    y2: 140.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m287.6 313.6-.1-.1.1-38.1.4-144.1-29.2-16.8-98.1-56.7-21.1-12.1-.4 144.7z",
    style: {
      opacity: 0.2,
      fill: "url(#hersteller_svg__SVGID_8_)"
    }
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hersteller_svg__SVGID_9_",
    x1: 373.239,
    x2: 389.642,
    y1: 271.352,
    y2: 225.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "m432.1 242.9-48 27.7-48.9-28.4 47.9-27.7z",
    style: {
      opacity: 0.2,
      fill: "url(#hersteller_svg__SVGID_9_)"
    }
  }));
};
export default SvgHersteller;